var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettlein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    height: 112,
    width: 112,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -668.3393,
    y1: -2661.9731,
    x2: -342.3198,
    y2: -2661.9731,
    gradientTransform: "matrix(0 1 -1 0 -2449.373 668.7856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBDFD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2244,
    style: {
      stopColor: "#BDDCB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    style: {
      stopColor: "#B2E0F9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.001,
    y: 0.446,
    style: {
      fill: "url(#SVGID_1_)"
    },
    width: 425.198,
    height: 326.02
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "256.959,140.85 258.917,140.85 258.917,326.784 293.603,326.784 293.603,140.85  295.563,140.85 295.563,136.409 256.959,136.409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "252.143,147.272 221.563,147.272 221.563,155.141 217.549,155.141 217.549,159.579  219.715,159.579 219.715,326.784 254.399,326.784 254.399,159.579 256.156,159.579 256.156,155.141 252.143,155.141  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "322.6,174.722 299.66,174.722 299.66,180.623 296.654,180.623 296.654,183.952  298.279,183.952 298.279,326.784 324.293,326.784 324.293,183.952 325.613,183.952 325.613,180.623 322.6,180.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "357.279,137.118 354.271,137.118 354.271,131.217 331.33,131.217 331.33,137.118  328.319,137.118 328.319,140.447 329.947,140.447 329.947,326.784 355.963,326.784 355.963,140.447 357.279,140.447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "386.254,167.798 387.76,167.798 387.76,326.784 414.404,326.784 414.404,167.798  415.916,167.798 415.916,164.388 386.254,164.388  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "382.552,172.733 359.064,172.733 359.064,178.777 355.982,178.777 355.982,182.184  357.645,182.184 357.645,326.784 384.291,326.784 384.291,182.184 385.642,182.184 385.642,178.777 382.552,178.777  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "9.282,140.85 11.242,140.85 11.242,326.784 45.93,326.784 45.93,140.85 47.889,140.85  47.889,136.409 9.282,136.409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "74.924,174.722 51.988,174.722 51.988,180.623 48.979,180.623 48.979,183.952  50.6,183.952 50.6,326.784 76.621,326.784 76.621,183.952 77.938,183.952 77.938,180.623 74.924,180.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "109.605,137.118 106.596,137.118 106.596,131.217 83.656,131.217 83.656,137.118  80.648,137.118 80.648,140.447 82.273,140.447 82.273,326.784 108.289,326.784 108.289,140.447 109.605,140.447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "138.58,167.798 140.088,167.798 140.088,326.784 166.732,326.784 166.732,167.798  168.242,167.798 168.242,164.388 138.58,164.388  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "134.881,172.733 111.389,172.733 111.389,178.777 108.311,178.777 108.311,182.184  109.971,182.184 109.971,326.784 136.615,326.784 136.615,182.184 137.965,182.184 137.965,178.777 134.881,178.777  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "189.006,193.819 171.386,193.819 171.386,198.352 169.078,198.352 169.078,200.909  170.324,200.909 170.324,326.784 190.311,326.784 190.311,200.909 191.317,200.909 191.317,198.352 189.006,198.352  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE2EE"
    },
    points: "213.338,160.398 195.713,160.398 195.713,164.931 193.399,164.931 193.399,167.489  194.649,167.489 194.649,326.784 214.636,326.784 214.636,167.489 215.648,167.489 215.648,164.931 213.338,164.931  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FEF6EC"
    },
    d: "M0.004,340.443h425.195V100.436c0-10.322-8.178-18.691-18.265-18.691 c-10.087,0-18.263,8.369-18.263,18.691c0,3.146,0.768,6.107,2.109,8.709c-2.334-1.109-4.926-1.746-7.67-1.746 c-10.088,0-18.266,8.369-18.266,18.691c0,3.912,1.18,7.541,3.186,10.541c-8.963,1.195-15.89,9.02-15.89,18.516 c0,3.773,1.102,7.277,2.98,10.215c-0.974-0.164-1.963-0.27-2.98-0.27c-10.086,0-18.264,8.367-18.264,18.691 c0,1.447,0.178,2.85,0.48,4.201c-3.145-2.623-7.157-4.201-11.529-4.201c-9.391,0-17.115,7.254-18.141,16.582 c-3.35-4.164-8.424-6.818-14.106-6.818c-3.4,0-6.571,0.967-9.297,2.623c0.12-0.858,0.202-1.73,0.202-2.623 c0-10.324-8.178-18.691-18.266-18.691c-5.365,0-10.178,2.383-13.52,6.156c-1.31-9.006-8.874-15.92-18.041-15.92 c-6.967,0-13.021,3.996-16.101,9.871c-3.305-3.386-7.873-5.483-12.92-5.483c-8.693,0-15.953,6.221-17.797,14.545 c-2.979-2.162-6.611-3.444-10.542-3.444c-8.892,0-16.294,6.511-17.921,15.126c-2.756-1.709-5.979-2.711-9.438-2.711 c-5.499,0-10.418,2.5-13.768,6.436c-2.81-6.623-9.248-11.26-16.757-11.26c-0.528,0-1.054,0.035-1.573,0.082 c1.003-2.316,1.573-4.875,1.573-7.574c0-10.322-8.177-18.689-18.263-18.689c-3.902,0-7.512,1.264-10.479,3.396 c-2.36-4.746-6.633-8.31-11.785-9.646c2.498-3.197,4-7.246,4-11.66c0-10.322-8.177-18.689-18.262-18.689 c-0.121,0-0.236,0.016-0.353,0.018c0.227-1.178,0.352-2.393,0.352-3.639c0-10.322-8.177-18.691-18.264-18.691 c-9.705,0-17.621,7.753-18.207,17.537c-2.127-0.891-4.451-1.388-6.893-1.388c-10.088,0-18.265,8.367-18.265,18.69 c0,0.012,0.003,0.026,0.003,0.037V340.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M425.199,340.443V125.896c-12.012,0.697-21.541,10.902-21.541,23.39 c0,4.904,1.475,9.451,3.988,13.215c-11.215,1.496-19.883,11.305-19.883,23.211c0,4.729,1.377,9.123,3.727,12.805 c-1.215-0.205-2.454-0.338-3.727-0.338c-12.621,0-22.854,10.49-22.854,23.433c0,1.814,0.222,3.571,0.602,5.267 c-3.936-3.289-8.953-5.267-14.429-5.267c-11.75,0-21.414,9.093-22.699,20.788c-4.19-5.221-10.538-8.549-17.648-8.549 c-4.253,0-8.222,1.213-11.63,3.289c0.145-1.078,0.25-2.17,0.25-3.289c0-12.942-10.232-23.432-22.855-23.432 c-6.715,0-12.735,2.988-16.916,7.717c-1.642-11.289-11.106-19.957-22.573-19.957c-8.719,0-16.294,5.01-20.148,12.373 c-4.137-4.244-9.85-6.871-16.166-6.871c-10.878,0-19.964,7.798-22.27,18.232c-3.728-2.709-8.271-4.316-13.188-4.316 c-11.129,0-20.392,8.162-22.426,18.963c-3.449-2.142-7.482-3.398-11.811-3.398c-6.879,0-13.036,3.133-17.227,8.066 c-3.514-8.303-11.57-14.115-20.965-14.115c-0.663,0-1.318,0.045-1.969,0.102c1.255-2.904,1.969-6.109,1.969-9.492 c0-12.941-10.232-23.432-22.852-23.432c-4.885,0-9.398,1.584-13.113,4.26c-2.951-5.951-8.298-10.42-14.747-12.096 c3.126-4.008,5.007-9.082,5.007-14.615c0-12.941-10.23-23.431-22.85-23.431c-0.15,0-0.295,0.02-0.443,0.023 c0.284-1.477,0.441-3,0.441-4.561c0-12.941-10.231-23.432-22.852-23.432c-0.473,0-0.938,0.02-1.403,0.049v219.955H425.199z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M147.689,33.346c0-12.55-10.174-22.722-22.722-22.722 c-5.367,0-10.296,1.864-14.185,4.977c-3.925-6.795-11.266-11.371-19.68-11.371c-12.548,0-22.721,10.174-22.721,22.721 c0,2.23,0.327,4.383,0.927,6.418c-0.31-0.012-0.615-0.022-0.927-0.022c-12.549,0-22.722,10.172-22.722,22.721 c0,12.549,10.173,22.722,22.722,22.722c7.329,0,13.843-3.473,17.997-8.858c0.492,12.115,10.463,21.785,22.697,21.785 c11.498,0,20.993-8.542,22.506-19.624c4.115,4.136,9.813,6.697,16.107,6.697c12.549,0,22.721-10.173,22.721-22.722 C170.41,43.518,160.238,33.346,147.689,33.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M347.689,105.812c0-12.549-10.174-22.721-22.722-22.721 c-5.367,0-10.296,1.864-14.186,4.977c-3.925-6.795-11.266-11.371-19.68-11.371c-12.548,0-22.721,10.173-22.721,22.722 c0,2.229,0.327,4.382,0.927,6.417c-0.31-0.012-0.615-0.023-0.927-0.023c-12.549,0-22.722,10.173-22.722,22.722 c0,12.549,10.173,22.722,22.722,22.722c7.329,0,13.843-3.473,17.997-8.858c0.492,12.114,10.463,21.785,22.697,21.785 c11.498,0,20.993-8.542,22.506-19.624c4.115,4.136,9.813,6.697,16.107,6.697c12.549,0,22.721-10.173,22.721-22.722 C370.41,115.984,360.238,105.812,347.689,105.812z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M126.359,60.103c4.104-2.535,6.848-7.062,6.848-12.241c0-7.949-6.443-14.395-14.395-14.395 c-5.219,0-9.775,2.788-12.301,6.946c-0.988-6.985-6.975-12.364-14.234-12.364c-7.949,0-14.396,6.445-14.396,14.394 c0,0.1,0.015,0.196,0.017,0.296c-0.01,0.002-0.02,0.006-0.032,0.008c0.002-0.102,0.016-0.201,0.016-0.304 c0-7.949-6.442-14.394-14.394-14.394c-7.949,0-14.395,6.445-14.395,14.394c0,0.159,0.02,0.314,0.022,0.472 c-1.15-0.297-2.351-0.472-3.595-0.472c-7.949,0-14.395,6.445-14.395,14.395c0,7.95,6.445,14.395,14.395,14.395 c1.375,0,2.701-0.204,3.962-0.565c-0.245,1.056-0.39,2.149-0.39,3.279c0,7.95,6.445,14.395,14.395,14.395 c7.951,0,14.394-6.444,14.394-14.395c0-1.065-0.122-2.102-0.343-3.102c0.477,0.111,0.96,0.198,1.453,0.261 c-0.713,1.707-1.11,3.579-1.11,5.545c0,7.95,6.446,14.395,14.396,14.395c6.642,0,12.219-4.505,13.879-10.622 c2.641,3.179,6.621,5.204,11.076,5.204c7.949,0,14.395-6.444,14.395-14.395C131.627,66.748,129.574,62.743,126.359,60.103z  M109.565,58.888c0.042,0.034,0.081,0.07,0.119,0.104c-0.035,0.022-0.073,0.044-0.108,0.067 C109.574,59.001,109.569,58.945,109.565,58.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.603,57.917c4.104-2.535,6.848-7.062,6.848-12.241c0-7.949-6.442-14.395-14.393-14.395 c-5.219,0-9.775,2.788-12.301,6.946c-0.989-6.985-6.975-12.364-14.234-12.364c-7.949,0-14.395,6.445-14.395,14.395 c0,0.1,0.014,0.196,0.016,0.296c-0.011,0.002-0.02,0.006-0.031,0.008c0.002-0.102,0.016-0.201,0.016-0.304 c0-7.949-6.444-14.395-14.395-14.395s-14.395,6.445-14.395,14.395c0,0.159,0.02,0.313,0.023,0.472 c-1.15-0.297-2.352-0.472-3.596-0.472c-7.95,0-14.395,6.445-14.395,14.395c0,7.95,6.444,14.394,14.395,14.394 c1.375,0,2.7-0.204,3.963-0.565c-0.246,1.056-0.391,2.149-0.391,3.279c0,7.95,6.444,14.395,14.395,14.395 s14.395-6.444,14.395-14.395c0-1.065-0.123-2.102-0.345-3.102c0.478,0.111,0.962,0.198,1.453,0.261 c-0.712,1.707-1.108,3.579-1.108,5.545c0,7.95,6.445,14.395,14.395,14.395c6.643,0,12.219-4.505,13.878-10.622 c2.642,3.179,6.622,5.204,11.077,5.204c7.949,0,14.395-6.444,14.395-14.395C393.871,64.563,391.817,60.558,388.603,57.917z  M371.81,56.702c0.04,0.034,0.08,0.07,0.119,0.104c-0.035,0.022-0.074,0.044-0.11,0.067 C371.817,56.815,371.814,56.76,371.81,56.702z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B4CE44"
    },
    points: "0.002,321.392 0.002,345.324 0.002,345.324 0.002,424.754 425.199,424.754  425.199,345.324 425.199,321.392  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#8CAC23"
    },
    d: "M127.768,424.754c2.096-1.373,3.428-3.398,3.428-5.66c0-3.678-3.5-6.73-8.109-7.361 H63.041c-5.457,0-9.881-3.352-9.881-7.486c0-4.135,4.424-7.486,9.881-7.486l32.885-0.125c4.879-0.459,8.658-3.604,8.658-7.426 c0-3.676-3.5-6.727-8.113-7.359H55.107c-5.455,0-9.879-3.35-9.879-7.486c0-4.133,4.424-7.486,9.879-7.486H76.57 c-0.57-0.078-1.162-0.125-1.768-0.125h53.852c5.459,0,9.883-3.353,9.883-7.488c0-4.133-4.424-7.484-9.883-7.484H26.392 c-5.457,0-9.883-3.353-9.883-7.488c0-4.133,4.426-7.486,9.883-7.486h97.955c5.459,0,9.885-3.35,9.885-7.484 c0-4.135-4.426-7.488-9.885-7.488h-58.27c-1.166,0-2.281-0.16-3.32-0.441H0.002v103.363H127.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#8CAC23"
    },
    d: "M290.533,424.645h134.666V321.391H293.857c-3.797,1.041-6.514,3.779-6.514,7.002 c0,4.119,4.426,7.459,9.885,7.459h51.727c-0.603,0-1.193,0.047-1.77,0.125h25.842c5.463,0,9.889,3.34,9.889,7.459 c0,4.121-4.426,7.459-9.889,7.459h-45.898c-4.613,0.629-8.117,3.67-8.117,7.332c0,3.807,3.781,6.939,8.664,7.396l24.434,0.125 c5.459,0,9.885,3.338,9.885,7.457c0,4.121-4.426,7.459-9.885,7.459h-63.99c-4.615,0.629-8.119,3.67-8.119,7.332 c0,4.119,4.428,7.457,9.889,7.457h51.725c-0.603,0-1.193,0.049-1.77,0.127h50.273c5.461,0,9.885,3.338,9.885,7.459 c0,4.117-4.424,7.457-9.885,7.457h-71.014c-0.605,0-1.195-0.047-1.766-0.125h-23.142c-5.457,0-9.889,3.338-9.889,7.459 c0,3.141,2.58,5.824,6.227,6.924V424.645z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6D43B"
    },
    d: "M354.943,260.357c0,22.084-17.904,39.986-39.988,39.986c-22.084,0-39.986-17.902-39.986-39.986 c0-22.084,17.902-39.987,39.986-39.987C337.039,220.37,354.943,238.273,354.943,260.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M338.242,279.398c-10.701,3.65-22.56,2.337-31.691-4.525 c-10.498-7.889-16.829-22.332-12.934-35.239c2.264-7.497,6.936-13.888,13.031-18.394c-18.096,3.825-31.68,19.883-31.68,39.117 c0,22.084,17.902,39.986,39.986,39.986c19.067,0,35.01-13.351,39.01-31.212C349.65,273.705,344.354,277.313,338.242,279.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M332.215,270.876c-0.361-0.425-0.98-0.814-1.56-0.814c-0.651,0-1.221,0.109-1.732,0.544 c-0.46,0.392-0.757,0.958-0.813,1.561c-0.059,0.622,0.141,1.255,0.545,1.731c0.359,0.425,0.982,0.814,1.561,0.814 c0.65,0,1.219-0.108,1.73-0.544c0.461-0.392,0.758-0.958,0.814-1.561C332.818,271.984,332.62,271.352,332.215,270.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M323.56,268.653c-0.039-0.04-0.076-0.08-0.113-0.119c-0.338-0.355-1.006-0.521-1.389-0.114 c-0.033,0.033-0.064,0.068-0.098,0.103c-0.281,0.3-0.457,0.633-0.383,1.061c0.088,0.497,0.508,0.885,1.01,0.933 C323.539,270.605,324.262,269.392,323.56,268.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M330.57,258.927c-1.838,0-2.121,2.86-0.272,2.86C332.138,261.787,332.42,258.927,330.57,258.927z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M339.622,267.275c-2.161,0-2.491,3.362-0.317,3.362 C341.467,270.638,341.797,267.275,339.622,267.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M347.371,259.435c-2.289,0-2.641,3.563-0.336,3.563 C349.324,262.998,349.676,259.435,347.371,259.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M339.589,254.727c-1.708,0-1.972,2.659-0.251,2.659 C341.047,257.387,341.31,254.727,339.589,254.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M342.584,239.425c-1.484,0-1.713,2.309-0.219,2.309 C343.848,241.733,344.076,239.425,342.584,239.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M349.08,247.092c-2.129,0-2.455,3.313-0.314,3.313 C350.895,250.404,351.222,247.092,349.08,247.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M336.986,246.379c-0.721-0.067-1.266,0.574-1.17,1.268c0.016,0.114,0.033,0.229,0.049,0.343 c0.063,0.454,0.477,0.81,0.922,0.851c0.578,0.055,1.049-0.374,1.127-0.933c0.018-0.115,0.033-0.231,0.049-0.348 C338.045,246.976,337.554,246.433,336.986,246.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M333.215,226.706c-0.014-0.006-0.029-0.012-0.043-0.017c-0.183-0.241-0.381-0.264-0.563-0.175 c-0.469-0.052-0.587,0.325-0.508,0.72c-0.1,0.387,0,0.761,0.457,0.741c0.18,0.104,0.385,0.084,0.582-0.154 c0.041-0.017,0.081-0.032,0.123-0.048C333.75,227.583,333.654,226.878,333.215,226.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M337.029,231.739c-1.969,0-2.271,3.061-0.29,3.061 C338.706,234.8,339.008,231.739,337.029,231.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M327.625,238.472c-2.711,0-3.125,4.215-0.4,4.215 C329.935,242.686,330.35,238.472,327.625,238.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M321.902,253.136c0.041-0.413-0.178-0.727-0.504-0.898c-0.346-0.325-0.883-0.458-1.348-0.331 c-0.537,0.147-0.984,0.448-1.188,0.996c-0.162,0.439-0.08,0.932,0.158,1.324c0.174,0.283,0.358,0.501,0.68,0.62 c0.391,0.146,0.904,0.084,1.213-0.213c0.031-0.031,0.064-0.062,0.098-0.088c-0.311,0.198-0.276,0.176,0.104-0.068 c0.211-0.179,0.389-0.455,0.469-0.742C321.758,253.584,321.881,253.379,321.902,253.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M305.184,259.127c-1.581,0-1.824,2.46-0.234,2.46 C306.531,261.587,306.772,259.127,305.184,259.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M310.322,265.373c-1.291,0-1.488,2.008-0.191,2.008 C311.422,267.381,311.619,265.373,310.322,265.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M303.08,246.981c-0.168-0.352-0.502-0.607-0.907-0.645c-0.61-0.058-1.171,0.404-1.227,1.016 c-0.06,0.611,0.404,1.171,1.016,1.229c0.445,0.042,0.816-0.176,1.033-0.514C303.299,247.811,303.318,247.311,303.08,246.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M312.008,247.666c-0.838,0-0.967,1.305-0.123,1.305 C312.722,248.971,312.852,247.666,312.008,247.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M320.645,244.684c-1.354,0-1.563,2.108-0.199,2.108 C321.801,246.792,322.008,244.684,320.645,244.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 309.998,
    y: 299.731,
    style: {
      fill: "#925628"
    },
    width: 5.223,
    height: 34.234
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#925628"
    },
    d: "M296.755,273.483c4.394,5.997,8.089,11.938,10.544,18.997 c2.492,7.169,3.842,14.947,3.922,22.535c0.02,1.787,2.81,2.053,2.777,0.264c-0.281-14.926-4.988-32.232-16.82-42.26 C296.889,272.773,296.555,273.21,296.755,273.483L296.755,273.483z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#925628"
    },
    d: "M332.709,272.701c-12.831,8.546-19.504,25.209-21.488,39.914 c-0.24,1.786,2.553,2.043,2.777,0.264c0.931-7.362,3.113-14.487,6.125-21.252c3.155-7.09,7.772-12.795,12.996-18.443 C333.396,272.884,333.052,272.473,332.709,272.701L332.709,272.701z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#925628"
    },
    d: "M311.326,267.998c-0.258,1.845,0.122,3.77,0.192,5.629c0.071,1.896,0.044,3.797,0.081,5.694 c0.084,4.154-0.053,8.322-0.166,12.476c-0.109,3.997-0.256,8.004-0.052,12.001c0.19,3.73-0.537,8.146,0.919,11.66 c0.298,0.718,1.308,0.577,1.576-0.07c1.379-3.327,0.718-7.627,0.559-11.149c-0.197-4.372-0.1-8.754-0.056-13.128 c0.04-3.972,0.017-7.926-0.249-11.89c-0.236-3.511-0.596-8.217-2.404-11.294C311.622,267.749,311.356,267.781,311.326,267.998 L311.326,267.998z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6D43B"
    },
    d: "M413.316,292.992c0,13.673-11.085,24.756-24.757,24.756s-24.755-11.083-24.755-24.756 c0-13.672,11.083-24.756,24.755-24.756S413.316,279.32,413.316,292.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M402.977,304.781c-6.625,2.26-13.967,1.446-19.62-2.802c-6.499-4.884-10.419-13.825-8.007-21.816 c1.401-4.642,4.294-8.599,8.067-11.388c-11.203,2.368-19.612,12.31-19.612,24.217c0,13.673,11.083,24.756,24.755,24.756 c11.805,0,21.675-8.266,24.151-19.323C410.039,301.256,406.761,303.49,402.977,304.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M399.245,299.505c-0.224-0.263-0.607-0.505-0.966-0.505c-0.403,0-0.756,0.068-1.072,0.338 c-0.285,0.242-0.469,0.593-0.504,0.966c-0.036,0.385,0.087,0.776,0.338,1.071c0.223,0.263,0.608,0.504,0.966,0.504 c0.402,0,0.755-0.066,1.071-0.337c0.285-0.242,0.47-0.593,0.504-0.966C399.619,300.191,399.496,299.799,399.245,299.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M393.888,298.129c-0.024-0.025-0.048-0.05-0.07-0.074c-0.209-0.22-0.623-0.322-0.86-0.07 c-0.021,0.021-0.039,0.042-0.06,0.063c-0.175,0.186-0.283,0.392-0.237,0.656c0.055,0.308,0.315,0.548,0.625,0.577 C393.874,299.338,394.321,298.586,393.888,298.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M398.227,292.107c-1.138,0-1.313,1.771-0.168,1.771 C399.197,293.878,399.372,292.107,398.227,292.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M403.831,297.275c-1.338,0-1.542,2.082-0.196,2.082 C404.973,299.357,405.178,297.275,403.831,297.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M408.628,292.422c-1.417,0-1.635,2.205-0.208,2.205 C409.838,294.627,410.055,292.422,408.628,292.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M403.81,289.508c-1.058,0-1.221,1.646-0.155,1.646 C404.713,291.154,404.876,289.508,403.81,289.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M405.665,280.033c-0.919,0-1.061,1.43-0.136,1.43 C406.447,281.463,406.589,280.033,405.665,280.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M409.686,284.78c-1.318,0-1.521,2.051-0.195,2.051C410.81,286.831,411.012,284.78,409.686,284.78 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M402.199,284.339c-0.446-0.042-0.783,0.355-0.725,0.784c0.01,0.071,0.02,0.143,0.03,0.213 c0.039,0.281,0.295,0.501,0.571,0.526c0.357,0.034,0.649-0.232,0.697-0.577c0.011-0.072,0.021-0.143,0.03-0.215 C402.854,284.708,402.551,284.372,402.199,284.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M399.864,272.159c-0.009-0.003-0.018-0.007-0.026-0.011c-0.113-0.148-0.236-0.162-0.349-0.107 c-0.29-0.032-0.363,0.201-0.314,0.445c-0.062,0.24,0,0.471,0.283,0.459c0.111,0.064,0.238,0.052,0.36-0.096 c0.025-0.01,0.05-0.02,0.076-0.029C400.195,272.702,400.137,272.266,399.864,272.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M402.225,275.275c-1.219,0-1.406,1.895-0.18,1.895 C403.264,277.17,403.45,275.275,402.225,275.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M396.403,279.443c-1.678,0-1.935,2.609-0.248,2.609 C397.833,282.053,398.091,279.443,396.403,279.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M392.86,288.522c0.025-0.256-0.109-0.45-0.311-0.556c-0.214-0.202-0.547-0.284-0.834-0.205 c-0.333,0.091-0.609,0.277-0.735,0.616c-0.1,0.273-0.05,0.577,0.098,0.82c0.107,0.176,0.222,0.311,0.421,0.384 c0.242,0.091,0.56,0.052,0.751-0.132c0.02-0.02,0.04-0.038,0.061-0.055c-0.192,0.123-0.171,0.109,0.063-0.042 c0.131-0.11,0.241-0.282,0.291-0.46C392.771,288.799,392.848,288.672,392.86,288.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M382.51,292.23c-0.979,0-1.129,1.523-0.145,1.523C383.345,293.754,383.494,292.23,382.51,292.23z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M385.691,296.098c-0.799,0-0.921,1.243-0.118,1.243 C386.372,297.341,386.494,296.098,385.691,296.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M381.208,284.712c-0.105-0.218-0.311-0.376-0.562-0.399c-0.378-0.036-0.726,0.25-0.76,0.629 c-0.037,0.378,0.25,0.725,0.628,0.76c0.276,0.026,0.506-0.108,0.64-0.318C381.344,285.225,381.355,284.916,381.208,284.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M386.735,285.136c-0.519,0-0.599,0.808-0.076,0.808 C387.177,285.943,387.258,285.136,386.735,285.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M392.082,283.29c-0.838,0-0.968,1.305-0.123,1.305 C392.798,284.595,392.926,283.29,392.082,283.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 385.491,
    y: 317.369,
    style: {
      fill: "#925628"
    },
    width: 3.233,
    height: 21.194
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#925628"
    },
    d: "M377.292,301.119c5.692,7.582,8.769,16.186,8.956,25.713c0.022,1.104,1.75,1.269,1.719,0.162 c-0.264-9.436-3.115-19.694-10.413-26.162C377.379,300.677,377.166,300.951,377.292,301.119L377.292,301.119z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#925628"
    },
    d: "M399.551,300.635c-7.947,5.543-11.967,15.431-13.303,24.711 c-0.159,1.104,1.57,1.264,1.719,0.164c1.285-9.475,5.293-17.668,11.838-24.576 C399.978,300.751,399.76,300.488,399.551,300.635L399.551,300.635z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#925628"
    },
    d: "M386.313,297.723c-0.21,4.787,0.2,9.652,0.073,14.463c-0.063,2.359-0.186,4.736-0.07,7.095 c0.123,2.524-0.206,5.258,0.558,7.689c0.142,0.453,0.842,0.651,1.018,0.092c0.699-2.215,0.436-4.579,0.347-6.874 c-0.101-2.609-0.065-5.219-0.038-7.83c0.049-4.757,0.375-10.25-1.64-14.678C386.51,297.564,386.318,297.593,386.313,297.723 L386.313,297.723z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.324,
    y: 241.96,
    style: {
      fill: "#70C8F2"
    },
    width: 278.928,
    height: 94.326
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.34,
    y: 331.038,
    style: {
      fill: "#70C8F2"
    },
    width: 278.927,
    height: 5.248
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.312,
    y: 241.96,
    style: {
      fill: "#DADADA"
    },
    width: 278.928,
    height: 22.119
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A05347"
    },
    points: "354.905,200.104 152.909,200.104 147.871,200.104 74.74,200.104 58.03,253.938  147.871,253.938 152.909,253.938 371.617,253.938  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DADADA"
    },
    points: "92.74,212.298 358.689,212.298 354.905,200.104 74.74,200.104 58.03,253.938  81.174,253.938  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 253.938,
    style: {
      fill: "#7D4236"
    },
    width: 313.587,
    height: 5.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#723C31"
    },
    points: "118.155,171.299 76.954,221 118.155,221 159.356,221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#70C8F2"
    },
    points: "118.155,180.375 84.479,221 118.155,221 151.833,221  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 118.155,
    cy: 205.058,
    r: 11.81
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#85C9DD"
    },
    cx: 118.155,
    cy: 205.058,
    r: 8.188
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.134,197.904l-11.345,10.711c0.255,0.528,0.565,1.027,0.925,1.485l11.861-11.168 C123.134,198.541,122.653,198.193,122.134,197.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M125.586,201.633c-0.252-0.545-0.562-1.058-0.923-1.529l-11.866,11.135 c0.449,0.391,0.937,0.737,1.463,1.022L125.586,201.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M126.276,204.059c-0.041-0.33-0.103-0.652-0.182-0.971l-10.436,9.767 c0.272,0.087,0.551,0.162,0.834,0.221L126.276,204.059z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#723C31"
    },
    points: "311.492,171.299 270.292,221 311.492,221 352.695,221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#70C8F2"
    },
    points: "311.492,180.375 277.816,221 311.492,221 345.171,221  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.303,205.058c0,6.522-5.288,11.81-11.811,11.81c-6.521,0-11.809-5.287-11.809-11.81 c0-6.523,5.287-11.81,11.809-11.81C318.015,193.248,323.303,198.535,323.303,205.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85C9DD"
    },
    d: "M319.681,205.058c0,4.521-3.666,8.188-8.189,8.188c-4.521,0-8.186-3.667-8.186-8.188 c0-4.523,3.666-8.189,8.186-8.189C316.015,196.869,319.681,200.535,319.681,205.058z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M315.472,197.904l-11.346,10.711c0.256,0.528,0.566,1.027,0.925,1.485l11.862-11.168 C316.472,198.541,315.991,198.193,315.472,197.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M318.924,201.633c-0.252-0.545-0.563-1.058-0.923-1.529l-11.866,11.135 c0.448,0.391,0.936,0.737,1.463,1.022L318.924,201.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M319.614,204.059c-0.041-0.33-0.103-0.652-0.182-0.971l-10.436,9.767 c0.272,0.087,0.55,0.162,0.834,0.221L319.614,204.059z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M118.546,280.986c-0.287-4.383-6.086-7.883-13.219-7.883c-7.13,0-12.93,3.5-13.217,7.883h-0.027 v55.322h26.491v-55.322H118.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85C9DD"
    },
    d: "M115.776,281.967c-0.228-3.464-4.811-6.23-10.449-6.23c-5.637,0-10.219,2.767-10.447,6.23 h-0.022v54.342h20.941v-54.342H115.776z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.015,
    y: 273.867,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.627,
    height: 62.441
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.857,
    y: 284.422,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.941,
    height: 1.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.857,
    y: 294.561,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.941,
    height: 1.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.857,
    y: 304.701,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.941,
    height: 1.969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.857,
    y: 314.842,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.941,
    height: 1.969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.857,
    y: 324.981,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.941,
    height: 1.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "94.857,319.905 115.799,281.967 115.799,284.422 94.857,322.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "94.857,326.105 115.799,288.167 115.799,290.621 94.857,329.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "94.857,332.306 115.799,294.367 115.799,296.822 94.857,335.303  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M162.86,280.986c-0.287-4.383-6.087-7.883-13.219-7.883c-7.13,0-12.929,3.5-13.216,7.883h-0.028 v55.322h26.491v-55.322H162.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85C9DD"
    },
    d: "M160.091,281.967c-0.228-3.464-4.81-6.23-10.449-6.23c-5.637,0-10.219,2.767-10.447,6.23h-0.023 v54.342h20.942v-54.342H160.091z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 148.329,
    y: 273.867,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.627,
    height: 62.441
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.172,
    y: 284.422,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.942,
    height: 1.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.172,
    y: 294.561,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.942,
    height: 1.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.172,
    y: 304.701,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.942,
    height: 1.969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.172,
    y: 314.842,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.942,
    height: 1.969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.172,
    y: 324.981,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.942,
    height: 1.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "139.172,319.905 160.114,281.967 160.114,284.422 139.172,322.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "139.172,326.105 160.114,288.167 160.114,290.621 139.172,329.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "139.172,332.306 160.114,294.367 160.114,296.822 139.172,335.303  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M295.783,280.986c-0.287-4.383-6.086-7.883-13.219-7.883c-7.131,0-12.929,3.5-13.217,7.883 h-0.027v55.322h26.49v-55.322H295.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85C9DD"
    },
    d: "M293.014,281.967c-0.229-3.464-4.811-6.23-10.449-6.23c-5.638,0-10.219,2.767-10.446,6.23 h-0.023v54.342h20.941v-54.342H293.014z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 281.251,
    y: 273.867,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.628,
    height: 62.441
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.095,
    y: 284.422,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.941,
    height: 1.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.095,
    y: 294.561,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.941,
    height: 1.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.095,
    y: 304.701,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.941,
    height: 1.969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.095,
    y: 314.842,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.941,
    height: 1.969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.095,
    y: 324.981,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.941,
    height: 1.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "272.095,319.905 293.036,281.967 293.036,284.422 272.095,322.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "272.095,326.105 293.036,288.167 293.036,290.621 272.095,329.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "272.095,332.306 293.036,294.367 293.036,296.822 272.095,335.303  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M340.098,280.986c-0.287-4.383-6.086-7.883-13.218-7.883c-7.132,0-12.93,3.5-13.218,7.883 h-0.028v55.322h26.492v-55.322H340.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85C9DD"
    },
    d: "M337.328,281.967c-0.228-3.464-4.811-6.23-10.448-6.23s-10.22,2.767-10.448,6.23h-0.022v54.342 h20.94v-54.342H337.328z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 325.566,
    y: 273.867,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.628,
    height: 62.441
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.41,
    y: 284.422,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.94,
    height: 1.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.41,
    y: 294.561,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.94,
    height: 1.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.41,
    y: 304.701,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.94,
    height: 1.969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.41,
    y: 314.842,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.94,
    height: 1.969
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.41,
    y: 324.981,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.94,
    height: 1.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "316.41,319.905 337.35,281.967 337.35,284.422 316.41,322.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "316.41,326.105 337.35,288.167 337.35,290.621 316.41,329.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "316.41,332.306 337.35,294.367 337.35,296.822 316.41,335.303  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9EABF"
    },
    points: "215.213,227.451 177.583,261.051 177.583,336.309 252.842,336.309 252.842,261.051  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DADADA"
    },
    points: "215.213,227.451 177.583,261.051 177.583,278.285 215.213,244.686 252.842,278.285  252.842,261.051  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.583,
    y: 330.647,
    style: {
      fill: "#D1B385"
    },
    width: 75.259,
    height: 5.661
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201.492,
    y: 289.56,
    style: {
      fill: "#925628"
    },
    width: 27.441,
    height: 46.748
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#70421C",
      strokeWidth: 0.9396,
      strokeMiterlimit: 10
    },
    points: "203.247,336.309  203.247,292.414 227.179,292.414 227.179,336.309  "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.923,
    y: 294.49,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.425,
    height: 9.249
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.923,
    y: 304.886,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.425,
    height: 9.249
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.923,
    y: 315.28,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.425,
    height: 9.251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.923,
    y: 325.675,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.425,
    height: 9.249
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#70421C"
    },
    d: "M225.885,314.363c0,1.051-0.852,1.904-1.905,1.904c-1.052,0-1.906-0.853-1.906-1.904 c0-1.054,0.855-1.906,1.906-1.906C225.033,312.457,225.885,313.31,225.885,314.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#593413"
    },
    d: "M225.233,314.363c0,0.693-0.561,1.254-1.254,1.254c-0.694,0-1.256-0.561-1.256-1.254 c0-0.694,0.561-1.258,1.256-1.258C224.673,313.105,225.233,313.669,225.233,314.363z"
  }))), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#723C31",
      strokeWidth: 6.5773,
      strokeMiterlimit: 10
    },
    points: "169.022,269.231  215.213,227.451 260.625,267.717  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.671,262.962c0,6.328-5.131,11.458-11.458,11.458c-6.328,0-11.457-5.13-11.457-11.458 c0-6.329,5.129-11.458,11.457-11.458C221.54,251.504,226.671,256.633,226.671,262.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85C9DD"
    },
    d: "M223.156,262.962c0,4.386-3.558,7.944-7.943,7.944c-4.388,0-7.944-3.559-7.944-7.944 c0-4.388,3.557-7.944,7.944-7.944C219.599,255.018,223.156,258.574,223.156,262.962z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M219.072,256.021l-11.008,10.392c0.25,0.514,0.55,0.998,0.899,1.441l11.508-10.834 C220.043,256.639,219.577,256.303,219.072,256.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M222.422,259.639c-0.245-0.529-0.545-1.025-0.895-1.484l-11.513,10.805 c0.436,0.377,0.908,0.715,1.419,0.99L222.422,259.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M223.092,261.992c-0.039-0.32-0.1-0.634-0.175-0.941l-10.126,9.477 c0.265,0.084,0.533,0.157,0.809,0.214L223.092,261.992z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#70C8F2"
    },
    points: "215.242,103.342 162.457,154.25 162.457,220.47 268.027,220.47 268.027,154.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DADADA"
    },
    points: "215.242,103.342 162.457,154.25 162.457,168.318 215.242,117.41 268.027,168.318  268.027,154.25  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 215.964,
    style: {
      fill: "#70C8F2"
    },
    width: 105.57,
    height: 4.506
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#7D3845",
      strokeWidth: 6.5773,
      strokeMiterlimit: 10
    },
    points: "153.247,160.594  215.242,103.342 276.401,160.594  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M227.57,141.551c0,6.808-5.52,12.328-12.329,12.328c-6.809,0-12.326-5.521-12.326-12.328 c0-6.811,5.518-12.328,12.326-12.328C222.05,129.223,227.57,134.74,227.57,141.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85C9DD"
    },
    d: "M223.789,141.551c0,4.719-3.828,8.547-8.548,8.547c-4.721,0-8.546-3.828-8.546-8.547 c0-4.722,3.825-8.549,8.546-8.549C219.961,133.002,223.789,136.829,223.789,141.551z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M219.395,134.081l-11.844,11.183c0.268,0.551,0.591,1.072,0.965,1.551l12.385-11.658 C220.439,134.747,219.938,134.385,219.395,134.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M222.999,137.975c-0.264-0.568-0.586-1.104-0.963-1.597l-12.388,11.624 c0.469,0.407,0.977,0.77,1.526,1.066L222.999,137.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M223.72,140.507c-0.043-0.345-0.108-0.682-0.189-1.014l-10.895,10.197 c0.285,0.091,0.574,0.168,0.87,0.23L223.72,140.507z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.282,
    y: 169.58,
    style: {
      fill: "#FFFFFF"
    },
    width: 36.829,
    height: 36.825
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.692,
    y: 172.988,
    style: {
      fill: "#85C9DD"
    },
    width: 30.01,
    height: 30.01
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "180.094,202.998 200.666,172.988 202.114,172.988 181.541,202.998  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "185.682,203.003 206.254,172.994 207.702,172.994 187.132,203.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "182.315,202.998 202.887,172.988 205.3,172.988 184.73,202.998  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.635,
    y: 172.998,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.125,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.698,
    y: 186.931,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.998,
    height: 2.124
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 221.534,
    y: 169.577,
    style: {
      fill: "#FFFFFF"
    },
    width: 36.83,
    height: 36.828
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.944,
    y: 172.987,
    style: {
      fill: "#85C9DD"
    },
    width: 30.01,
    height: 30.01
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "227.346,202.997 247.916,172.987 249.364,172.987 228.793,202.997  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "232.934,203.003 253.504,172.994 254.954,172.994 234.384,203.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "229.567,202.997 250.139,172.987 252.552,172.987 231.981,202.997  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.887,
    y: 172.998,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.125,
    height: 29.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.95,
    y: 186.93,
    style: {
      fill: "#FFFFFF"
    },
    width: 29.998,
    height: 2.125
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6D43B"
    },
    d: "M137.107,264.899c0,22.084-17.904,39.986-39.988,39.986s-39.986-17.902-39.986-39.986 c0-22.084,17.902-39.987,39.986-39.987S137.107,242.815,137.107,264.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M120.406,283.94c-10.701,3.65-22.56,2.337-31.692-4.525 c-10.497-7.889-16.827-22.332-12.934-35.239c2.265-7.497,6.937-13.888,13.032-18.394c-18.096,3.825-31.68,19.883-31.68,39.117 c0,22.084,17.902,39.986,39.986,39.986c19.068,0,35.01-13.351,39.01-31.212C131.814,278.247,126.52,281.854,120.406,283.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M114.379,275.418c-0.361-0.425-0.98-0.814-1.559-0.814c-0.652,0-1.222,0.109-1.732,0.544 c-0.461,0.392-0.759,0.958-0.814,1.561c-0.06,0.622,0.14,1.255,0.545,1.73c0.359,0.425,0.981,0.815,1.561,0.815 c0.65,0,1.219-0.108,1.73-0.544c0.461-0.392,0.757-0.958,0.814-1.561C114.982,276.526,114.785,275.893,114.379,275.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M105.725,273.195c-0.039-0.04-0.076-0.08-0.113-0.119c-0.338-0.355-1.006-0.521-1.389-0.114 c-0.033,0.033-0.064,0.068-0.098,0.102c-0.281,0.3-0.457,0.633-0.383,1.061c0.087,0.497,0.507,0.885,1.01,0.933 C105.703,275.147,106.426,273.934,105.725,273.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M112.734,263.469c-1.838,0-2.122,2.86-0.272,2.86 C114.303,266.329,114.583,263.469,112.734,263.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M121.787,271.817c-2.162,0-2.492,3.362-0.318,3.362 C123.63,275.18,123.961,271.817,121.787,271.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M129.535,263.978c-2.29,0-2.641,3.563-0.336,3.563 C131.488,267.54,131.84,263.978,129.535,263.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M121.754,259.27c-1.709,0-1.974,2.659-0.252,2.659 C123.211,261.929,123.475,259.27,121.754,259.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M124.748,243.967c-1.485,0-1.713,2.309-0.219,2.309 C126.012,246.275,126.24,243.967,124.748,243.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M131.244,251.634c-2.129,0-2.455,3.313-0.314,3.313 C133.059,254.946,133.387,251.634,131.244,251.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M119.149,250.921c-0.72-0.067-1.265,0.574-1.169,1.268c0.016,0.114,0.033,0.229,0.049,0.343 c0.063,0.454,0.477,0.81,0.922,0.851c0.578,0.055,1.049-0.374,1.127-0.933c0.018-0.115,0.033-0.232,0.049-0.348 C120.209,251.518,119.719,250.975,119.149,250.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M115.379,231.248c-0.015-0.006-0.029-0.012-0.043-0.017c-0.182-0.241-0.381-0.264-0.563-0.175 c-0.469-0.052-0.586,0.325-0.508,0.72c-0.101,0.387,0,0.761,0.457,0.741c0.18,0.104,0.385,0.084,0.582-0.154 c0.041-0.017,0.082-0.032,0.123-0.048C115.913,232.125,115.818,231.42,115.379,231.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M119.193,236.281c-1.969,0-2.271,3.061-0.289,3.061 C120.871,239.342,121.172,236.281,119.193,236.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M109.789,243.014c-2.711,0-3.125,4.215-0.4,4.215 C112.099,247.229,112.514,243.014,109.789,243.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M104.067,257.678c0.04-0.413-0.179-0.728-0.505-0.898c-0.346-0.325-0.884-0.458-1.349-0.331 c-0.536,0.147-0.983,0.448-1.187,0.996c-0.163,0.439-0.08,0.932,0.158,1.324c0.174,0.283,0.357,0.501,0.679,0.62 c0.392,0.145,0.905,0.084,1.214-0.213c0.031-0.031,0.064-0.062,0.098-0.088c-0.312,0.198-0.276,0.176,0.104-0.068 c0.211-0.179,0.389-0.455,0.469-0.742C103.922,258.126,104.045,257.921,104.067,257.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M87.347,263.669c-1.579,0-1.823,2.46-0.234,2.46C88.695,266.129,88.938,263.669,87.347,263.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M92.486,269.915c-1.291,0-1.489,2.008-0.191,2.008C93.586,271.923,93.783,269.915,92.486,269.915 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M85.244,251.523c-0.168-0.352-0.502-0.607-0.906-0.646c-0.611-0.058-1.173,0.404-1.229,1.016 c-0.06,0.611,0.404,1.171,1.016,1.229c0.445,0.042,0.816-0.176,1.033-0.514C85.462,252.352,85.482,251.852,85.244,251.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M94.172,252.208c-0.839,0-0.967,1.305-0.123,1.305C94.887,253.513,95.015,252.208,94.172,252.208 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808C28"
    },
    d: "M102.809,249.227c-1.354,0-1.563,2.107-0.199,2.107 C103.965,251.334,104.172,249.227,102.809,249.227z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.162,
    y: 304.273,
    style: {
      fill: "#925628"
    },
    width: 5.223,
    height: 34.234
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#925628"
    },
    d: "M78.919,278.025c4.394,5.997,8.089,11.938,10.544,18.997 c2.492,7.169,3.842,14.948,3.922,22.535c0.02,1.788,2.811,2.053,2.777,0.264c-0.281-14.926-4.988-32.232-16.82-42.261 C79.053,277.315,78.719,277.752,78.919,278.025L78.919,278.025z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#925628"
    },
    d: "M114.873,277.243c-12.831,8.546-19.504,25.209-21.488,39.914 c-0.24,1.786,2.553,2.043,2.777,0.264c0.931-7.362,3.113-14.487,6.125-21.251c3.155-7.092,7.771-12.797,12.996-18.444 C115.561,277.426,115.216,277.016,114.873,277.243L114.873,277.243z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#925628"
    },
    d: "M93.491,272.539c-0.258,1.846,0.122,3.77,0.192,5.629c0.071,1.896,0.043,3.798,0.08,5.695 c0.083,4.154-0.054,8.322-0.166,12.475c-0.109,3.998-0.256,8.006-0.052,12.002c0.19,3.73-0.537,8.145,0.919,11.66 c0.298,0.717,1.308,0.577,1.576-0.07c1.379-3.327,0.718-7.627,0.559-11.149c-0.197-4.372-0.1-8.754-0.057-13.128 c0.041-3.973,0.018-7.926-0.248-11.891c-0.236-3.51-0.594-8.216-2.403-11.293C93.787,272.291,93.521,272.324,93.491,272.539 L93.491,272.539z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#648E32"
    },
    points: "82.654,317.248 91.715,317.361 80.249,300.713 88.633,300.842 73.397,282.027  57.794,300.536 66.177,300.665 54.384,316.991 63.444,317.103 50.919,338.978 72.831,339.196 94.743,339.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6C6C6"
    },
    points: "73.731,282.438 73.397,282.027 57.794,300.536 66.177,300.665 54.384,316.991  63.444,317.103 50.919,338.978 72.831,339.196 73.731,339.205  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.718,
    y: 339.149,
    style: {
      fill: "#925628"
    },
    width: 6.225,
    height: 7.352
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#648E32"
    },
    points: "47.443,301.047 60.567,301.211 43.959,277.096 56.103,277.282 34.034,250.027  11.431,276.84 23.574,277.025 6.491,300.674 19.616,300.838 1.472,332.525 33.213,332.84 64.954,333.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6C6C6"
    },
    points: "34.518,250.623 34.034,250.027 11.431,276.84 23.574,277.025 6.491,300.674  19.616,300.838 1.472,332.525 33.213,332.84 34.518,332.853  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.703,
    y: 332.772,
    style: {
      fill: "#925628"
    },
    width: 9.017,
    height: 10.65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#648E32"
    },
    points: "337.824,329.781 343.929,329.856 336.204,318.641 341.852,318.728 331.588,306.051  321.075,318.522 326.723,318.607 318.777,329.607 324.882,329.684 316.442,344.422 331.206,344.568 345.969,344.714  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6C6C6"
    },
    points: "331.813,306.328 331.588,306.051 321.075,318.522 326.723,318.607 318.777,329.607  324.882,329.684 316.442,344.422 331.206,344.568 331.813,344.574  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.108,
    y: 344.536,
    style: {
      fill: "#925628"
    },
    width: 4.193,
    height: 4.954
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AB03B"
    },
    d: "M28.533,353.529c-0.569,0.871-0.903,1.91-0.903,3.029c0,0.344,0.037,0.68,0.098,1.008h30.316 c-0.005-0.027-0.006-0.053-0.01-0.08c2.457-0.568,4.291-2.766,4.291-5.396c0-2.305-1.408-4.281-3.412-5.115 c0.222-0.6,0.349-1.244,0.349-1.92c0-3.063-2.48-5.543-5.542-5.543c-1.943,0-3.65,1.002-4.64,2.516 c-0.952-1.68-2.753-2.816-4.822-2.816c-0.98,0-1.9,0.258-2.698,0.703c-0.498-2.549-2.742-4.477-5.439-4.477 c-3.059,0-5.542,2.482-5.542,5.543c0,0.662,0.123,1.295,0.336,1.883c-0.64-0.258-1.338-0.402-2.068-0.402 c-3.061,0-5.543,2.482-5.543,5.543C23.304,350.959,25.619,353.367,28.533,353.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AB03B"
    },
    d: "M383.862,340.994c-0.569,0.871-0.903,1.91-0.903,3.027c0,0.346,0.037,0.682,0.098,1.008h30.316 c-0.005-0.025-0.006-0.053-0.01-0.08c2.457-0.566,4.29-2.764,4.29-5.395c0-2.305-1.407-4.281-3.411-5.117 c0.222-0.598,0.349-1.244,0.349-1.92c0-3.06-2.48-5.541-5.542-5.541c-1.944,0-3.65,1-4.64,2.516 c-0.952-1.682-2.754-2.816-4.822-2.816c-0.98,0-1.899,0.258-2.698,0.703c-0.498-2.551-2.742-4.477-5.439-4.477 c-3.061,0-5.542,2.48-5.542,5.543c0,0.662,0.123,1.293,0.336,1.883c-0.64-0.258-1.338-0.402-2.069-0.402 c-3.061,0-5.542,2.48-5.542,5.541C378.633,338.424,380.948,340.83,383.862,340.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AB03B"
    },
    d: "M86.662,344.96c-0.569,0.871-0.903,1.91-0.903,3.028c0,0.345,0.037,0.681,0.098,1.008h30.316 c-0.005-0.026-0.006-0.053-0.01-0.08c2.457-0.567,4.29-2.765,4.29-5.395c0-2.305-1.407-4.281-3.411-5.116 c0.222-0.599,0.349-1.244,0.349-1.92c0-3.062-2.48-5.542-5.542-5.542c-1.944,0-3.65,1.001-4.64,2.516 c-0.952-1.681-2.754-2.816-4.822-2.816c-0.981,0-1.899,0.258-2.698,0.703c-0.498-2.55-2.742-4.477-5.438-4.477 c-3.061,0-5.542,2.482-5.542,5.543c0,0.662,0.123,1.294,0.336,1.883c-0.64-0.258-1.338-0.402-2.069-0.402 c-3.061,0-5.542,2.481-5.542,5.542C81.433,342.39,83.748,344.797,86.662,344.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#432918"
    },
    d: "M280.189,162.365c0.563,20.114-14.797,24.729-18.982,24.729c-4.186,0-18.072-5.816-17.582-23.374 c-2.776-12.463,5.457-23.539,16.762-24.285c4.588-0.302,10.328,0.871,13.04,5.477C279.676,146.901,281.916,154.99,280.189,162.365 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M266.732,366.283c0,0,5.465,11.909,7.535,14.382c2.072,2.471,8.68,2.078,5.395-2.041 c-3.287-4.119-6.963-12.234-6.963-12.234s3.522-49.102,4.107-62.808c0.412-9.618-0.357-32.054-0.357-32.054l-13.137,0.982 c0,0,3.224,23.38,3.132,31.08C262.217,311.362,266.906,338.634,266.732,366.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M275.297,379.79c-1.154-2.12-2.928-8.069-5.011-11.548c-0.698-1.163,1.31-1.872,1.31-1.872 c0.008-1.203-2.449-2.451-2.467-3.652c-0.254-18.792-3.261-37.037-3.014-48.656c0.099-4.692,3.168-8.261,4.33-10.398 c0.02-1.556-2.609-4.168-2.313-6.671c0.797-6.743,8.755-5.433,8.755-5.433l-0.427-19.662c-0.008-0.232-0.012-0.369-0.012-0.369 l-13.137,0.982c0,0,3.224,23.38,3.132,31.08c-4.228,7.772,0.462,35.043,0.288,62.692c0,0,5.465,11.909,7.535,14.382 c1.16,1.384,4.71,1.977,7.029,1.508C279.996,381.906,276.44,381.888,275.297,379.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEADB"
    },
    d: "M274.829,322.523c-0.178,9.916-2.038,24.172-2.038,24.172s0.466-14.28,0.643-24.197 c0.176-9.915,1.797-12.847,1.797-12.847S275.004,312.606,274.829,322.523z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M257.236,366.283c0,0-5.463,11.908-7.536,14.382c-2.07,2.471-9.91,1.23-6.146-2.457 c4.314-4.222,7.716-11.818,7.716-11.818s-3.521-49.102-4.108-62.809c-0.412-9.617,0.357-32.055,0.357-32.055l13.137,0.984 c0,0-3.225,23.38-3.132,31.08C261.752,311.362,257.063,338.634,257.236,366.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M248.671,379.79c1.155-2.122,2.928-8.071,5.011-11.548c0.699-1.165-1.309-1.872-1.309-1.872 c-0.008-1.203,2.45-2.451,2.467-3.652c0.256-18.792,3.262-37.037,3.014-48.658c-0.1-4.691-3.167-8.259-4.328-10.396 c-0.021-1.556,2.608-4.168,2.312-6.671c-0.796-6.743-8.756-5.433-8.756-5.433l0.427-19.662c0.008-0.232,0.012-0.371,0.012-0.371 l13.137,0.984c0,0-3.225,23.38-3.132,31.08c4.227,7.772-0.461,35.043-0.288,62.692c0,0-5.463,11.908-7.536,14.382 c-1.159,1.384-4.708,1.977-7.029,1.508C243.971,381.906,247.529,381.888,248.671,379.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEADB"
    },
    d: "M249.141,322.523c0.178,9.916,2.04,24.171,2.04,24.171s-0.468-14.279-0.646-24.196 c-0.176-9.917-1.797-12.847-1.797-12.847S248.965,312.606,249.141,322.523z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#093B59"
    },
    d: "M277.127,364.837c-6.841,3.405-12.023-0.357-12.023-0.357l-2.896-93.778l-1.143-0.364 l-1.375,94.409c0,0-6.818,4.997-13.079,0c-0.108-1.923-5.894-102.733-5.64-109.42c0.255-6.688,2.719-10.966,2.719-10.966 l8.652-1.028l19.938-0.162l7.041,0.834c0,0,2.084,4.677,1.823,10.52C280.883,260.368,278.425,363.055,277.127,364.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAC3D1"
    },
    d: "M242.27,267.445c0.488-2.213,1.344-4.371,2.754-6.169c3.396-4.329,8.364-6.219,13.654-7.178 c4.826-0.875,10.031-1.037,14.67-2.735c3.412-1.247,5.397-3.356,6.483-5.989c-0.29-0.867-0.511-1.369-0.511-1.369l-7.041-0.834 l-19.938,0.162l-8.652,1.028c0,0-2.464,4.278-2.719,10.966c-0.059,1.506,0.191,7.787,0.613,16.63 C241.904,270.216,242.048,268.446,242.27,267.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAC3D1"
    },
    d: "M276.555,359.156c-7.291-4.386-7.49-11.175-7.273-19.078c0.357-13.032,1.508-26.067,1.639-39.098 c0.081-7.874-0.338-15.147-3.248-22.524c-0.512-1.301-3.184-8.256-5.635-7.808l0.17,0.054l2.896,93.778 c0,0,5.183,3.762,12.023,0.357c0.164-0.227,0.346-2.067,0.541-5.113C277.303,359.563,276.934,359.384,276.555,359.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAC3D1"
    },
    d: "M255.37,284.157c-2.366,11.182-1.845,22.525-2.087,33.876c-0.242,11.314,0.09,23.486-2.266,34.609 c-0.773,3.66-2.264,6.233-4.668,7.533c0.154,2.703,0.248,4.343,0.261,4.571c6.261,4.997,13.079,0,13.079,0l1.361-93.543 C257.576,273.935,256.219,280.149,255.37,284.157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49819"
    },
    d: "M281.297,253.329c0,0-4.812,4.762-19.156,4.583c-14.344-0.178-20.938-5.299-20.938-5.299 l2.518-20.767l-1.984-35.977l10.164-3.888l20.947-0.162l9.676,4.252l-3.197,35.095L281.297,253.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M251.9,191.982c0,0-1.699,5.699,10.039,5.699c12.041,0,10.908-5.861,10.908-5.861l-3.512-0.977 l-1.551-10.228h-11.691l-0.828,10.1L251.9,191.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M260.137,189.352c3.244-2.072,6.537-2.836,6.527-7.468c-0.002-0.426-0.025-0.848-0.047-1.269 h-10.523l-0.828,10.1l-3.365,1.267c0,0-1.699,5.699,10.039,5.699C255.233,195.809,257.263,191.188,260.137,189.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M267.458,185.436l0.327-4.819h-11.691l0.623,5.09c0,0,3.436,3.525,6.654,3.16 C266.588,188.5,267.458,185.436,267.458,185.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M276.695,162.858c0.199,2.512-0.355,8.701-0.744,10.993c-1.051,6.234-7.595,13.263-14.037,13.263 c-7.787,0-11.357-6.795-13.709-11.863c-1.145-2.466-1.076-8.212-1.076-11.258c0-12.687,6.619-20.326,14.785-20.326 C270.077,143.667,275.521,147.898,276.695,162.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M254.992,170.664c0.141-1.08,0.365-2.146,0.66-3.192c0.111-0.553,0.246-1.105,0.408-1.656 c0.197-1.197,0.54-2.387,1.049-3.544c1.379-3.132,3.297-5.935,5.588-8.269c2.389-2.845,5.16-5.372,8.145-7.668 c-2.421-1.916-5.428-2.668-8.93-2.668c-8.451,0-15.302,7.64-15.302,20.326c0,3.046,0.411,8.792,1.595,11.258 c2.434,5.068,5.869,11.863,13.707,11.863c0.031,0,0.07-0.008,0.102-0.01C256.695,183.602,254.041,177.9,254.992,170.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M250.66,167.921c0,2.449-0.57,3.445-2.68,4.152c-3.309,1.109-3.918-2.866-4.84-5.186 c-0.974-2.454,1.779-8.579,5.4-1.869C250.809,165.018,250.66,165.472,250.66,167.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M250.66,167.921c0,2.449-0.57,3.445-2.68,4.152c-3.309,1.109-3.918-2.866-4.84-5.186 c-0.974-2.454,1.779-8.579,5.4-1.869C250.809,165.018,250.66,165.472,250.66,167.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M272.866,167.921c0,2.449,0.573,3.445,2.69,4.152c3.318,1.109,3.929-2.866,4.854-5.186 c0.978-2.454-1.786-8.579-5.418-1.869C272.717,165.018,272.866,165.472,272.866,167.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#432918"
    },
    d: "M272.49,145.543c0.058,0.118,3.957,6.274,4.766,12.311c0.589,4.4-1.084,10.54-1.439,10.702 c0.747-8.711-4.243-8.798-4.19-16.163c-1.063,1.961-3.676,2.585-8.93,1.61c-7.631-1.415-9.24,0.361-12.035,3.204 c-2.98,3.03-1.711,12.898-2.347,13.09c-1.073,0.324-1.901-8.087-2.074-8.44c-0.437-0.896-2.407-3.179-0.639-8.661 c-4.247-3.056-3.563-9.528-3.563-9.528s4.763,2.09,11.777-1.149C267.185,136.347,271.828,144.184,272.49,145.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M261.897,163.106c0,0,0.074,6.646-0.072,6.692c0.22,0.067,0.422,0.183,0.598,0.331 c0.403,0.347,0.665,0.89,0.665,1.5c0,0.878-0.535,1.609-1.263,1.832c0.146,0.045,0.298,0.076,0.458,0.076 c0.947,0,1.716-0.854,1.716-1.908c0-0.951-0.627-1.741-1.446-1.886C262.465,169.731,261.897,163.106,261.897,163.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#432918"
    },
    d: "M272.914,162.733c0,0-1.387-1.613-5.102-1.004c-0.954,0.156-1.901,1.17-1.901,0.61 s-0.681-1.575,0.274-1.729c3.469-0.555,5.468,0.004,6.301,0.808C272.985,161.9,272.914,162.733,272.914,162.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#432918"
    },
    d: "M251.082,162.733c0,0,1.385-1.613,5.099-1.004c0.954,0.156,1.903,1.17,1.903,0.61 s0.68-1.575-0.275-1.729c-3.467-0.555-5.469,0.004-6.301,0.808C251.008,161.9,251.082,162.733,251.082,162.733z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M269.078,171.751c0,0.223-0.297,0.405-0.664,0.405c-0.364,0-0.662-0.183-0.662-0.405 c0-0.224,0.298-0.406,0.662-0.406C268.781,171.345,269.078,171.527,269.078,171.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M270.699,172.087c0,0.139-0.215,0.25-0.481,0.25c-0.269,0-0.484-0.111-0.484-0.25 s0.216-0.251,0.484-0.251C270.484,171.836,270.699,171.948,270.699,172.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M272.535,171.836c0,0.138-0.217,0.251-0.484,0.251c-0.267,0-0.482-0.113-0.482-0.251 c0-0.138,0.216-0.249,0.482-0.249C272.318,171.587,272.535,171.698,272.535,171.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M269.56,172.744c0,0.062-0.139,0.109-0.31,0.109c-0.172,0-0.313-0.048-0.313-0.109 c0-0.061,0.141-0.11,0.313-0.11C269.422,172.634,269.56,172.683,269.56,172.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M273.107,171.345c0,0.062-0.103,0.11-0.227,0.11s-0.225-0.049-0.225-0.11 c0-0.061,0.101-0.109,0.225-0.109S273.107,171.284,273.107,171.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M270.443,173.184c0,0.062-0.102,0.111-0.226,0.111c-0.126,0-0.226-0.05-0.226-0.111 c0-0.063,0.1-0.111,0.226-0.111C270.342,173.073,270.443,173.122,270.443,173.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M271.37,172.446c0,0.063-0.139,0.11-0.312,0.11c-0.173,0-0.311-0.048-0.311-0.11 c0-0.061,0.139-0.109,0.311-0.109C271.231,172.337,271.37,172.386,271.37,172.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M271.012,171.345c0,0.062-0.141,0.11-0.313,0.11c-0.17,0-0.311-0.049-0.311-0.11 c0-0.061,0.141-0.109,0.311-0.109C270.871,171.235,271.012,171.284,271.012,171.345z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#432918"
    },
    d: "M269.816,165.825c0,0.8-0.529,1.447-1.186,1.447c-0.654,0-1.185-0.647-1.185-1.447 c0-0.798,0.531-1.446,1.185-1.446C269.287,164.379,269.816,165.027,269.816,165.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.647,165.218c0,0.273-0.223,0.494-0.497,0.494c-0.271,0-0.494-0.221-0.494-0.494 c0-0.274,0.223-0.495,0.494-0.495C268.425,164.723,268.647,164.943,268.647,165.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.861,165.747c0,0.139-0.112,0.252-0.251,0.252c-0.141,0-0.254-0.113-0.254-0.252 c0-0.139,0.113-0.253,0.254-0.253C268.749,165.494,268.861,165.608,268.861,165.747z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M255.182,171.751c0,0.223,0.295,0.405,0.662,0.405c0.366,0,0.662-0.183,0.662-0.405 c0-0.224-0.296-0.406-0.662-0.406C255.477,171.345,255.182,171.527,255.182,171.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M253.559,172.087c0,0.139,0.217,0.25,0.483,0.25s0.483-0.111,0.483-0.25s-0.217-0.251-0.483-0.251 S253.559,171.948,253.559,172.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M251.725,171.836c0,0.138,0.217,0.251,0.484,0.251c0.267,0,0.483-0.113,0.483-0.251 c0-0.138-0.216-0.249-0.483-0.249C251.941,171.587,251.725,171.698,251.725,171.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M254.697,172.744c0,0.062,0.141,0.109,0.311,0.109c0.173,0,0.312-0.048,0.312-0.109 c0-0.061-0.139-0.11-0.312-0.11C254.838,172.634,254.697,172.683,254.697,172.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M251.151,171.345c0,0.062,0.103,0.11,0.226,0.11c0.126,0,0.225-0.049,0.225-0.11 c0-0.061-0.099-0.109-0.225-0.109C251.254,171.235,251.151,171.284,251.151,171.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M253.816,173.184c0,0.062,0.101,0.111,0.225,0.111c0.124,0,0.225-0.05,0.225-0.111 c0-0.063-0.101-0.111-0.225-0.111C253.918,173.073,253.816,173.122,253.816,173.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M252.89,172.446c0,0.063,0.139,0.11,0.311,0.11c0.172,0,0.311-0.048,0.311-0.11 c0-0.061-0.139-0.109-0.311-0.109C253.028,172.337,252.89,172.386,252.89,172.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M253.248,171.345c0,0.062,0.139,0.11,0.311,0.11c0.172,0,0.311-0.049,0.311-0.11 c0-0.061-0.139-0.109-0.311-0.109C253.387,171.235,253.248,171.284,253.248,171.345z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#432918"
    },
    d: "M254.954,165.825c0,0.8,0.532,1.447,1.186,1.447c0.658,0,1.188-0.647,1.188-1.447 c0-0.798-0.529-1.446-1.188-1.446C255.486,164.379,254.954,165.027,254.954,165.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256.125,165.218c0,0.273,0.222,0.494,0.496,0.494c0.273,0,0.496-0.221,0.496-0.494 c0-0.274-0.223-0.495-0.496-0.495C256.347,164.723,256.125,164.943,256.125,165.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M255.91,165.747c0,0.139,0.114,0.252,0.254,0.252c0.139,0,0.252-0.113,0.252-0.252 c0-0.139-0.113-0.253-0.252-0.253C256.024,165.494,255.91,165.608,255.91,165.747z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5A7A6"
    },
    d: "M270.109,152.259c0,0-2.227,1.871-5.837,0.936c-3.61-0.936-16.341,2.278-19.261-0.936 c-2.92-3.215-2.793-7.488-2.793-7.488s1.459,4.145,5.338,5.616c3.877,1.472,10.945-1.203,14.766-0.268 C266.145,151.056,270.109,152.259,270.109,152.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#432918"
    },
    d: "M247.227,169.643c0.122,2.195-0.42,7.399,0,8.734c1.588,5.039,6.656,8.736,14.688,8.736 c8.028,0,13.662-3.6,14.714-9.836c0.156-0.928-0.335-5.93-0.185-7.635c0,0-3.305,6.195-5.97,6.82 c-2.465,0.576-4.899-2.151-8.556-2.23c-3.67-0.077-6.456,3.29-8.971,2.318C249.7,175.297,247.227,169.643,247.227,169.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M267.045,177.567c0.295,1.119,0.067,3.442-2.04,4.246c-1.488,0.566-2.323-2.475-3.18-2.475 c-0.632,0-1.618,3.425-3.673,2.808c-1.338-0.401-1.736-2.979-1.584-4.036c0.137-0.953,3.85-1.992,5.257-1.992 C263.236,176.118,266.664,176.118,267.045,177.567z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M265.95,177.784c0.017,0-0.037,0.145-0.251,0.272c-0.209,0.117-0.527,0.256-0.924,0.344 c-0.396,0.09-0.861,0.179-1.362,0.222c-0.501,0.064-1.034,0.057-1.569,0.079c-0.547-0.006-1.063-0.022-1.566-0.063 c-0.506-0.054-0.973-0.128-1.369-0.225c-0.397-0.082-0.717-0.229-0.922-0.351c-0.213-0.13-0.259-0.278-0.244-0.278 c-0.015,0.009,0.076,0.119,0.291,0.185c0.212,0.077,0.537,0.115,0.926,0.148c0.388,0.047,0.848,0.029,1.334,0.05 c0.489-0.005,1.033,0.005,1.548,0c0.524-0.012,1.054,0.004,1.544-0.014c0.492-0.009,0.951-0.008,1.342-0.049 c0.388-0.037,0.713-0.069,0.929-0.142C265.869,177.898,265.965,177.796,265.95,177.784z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#683C11"
    },
    d: "M241.232,378.97c0,0,5.77-4.958,6.779-7.804c1.014-2.847,0.09-4.197,2.596-3.945 c3.574,3.277,6.629-0.938,6.629-0.938c-0.441,1.313,3.435,3.796,0.557,7.613c-3.39,4.492-6.213,11.065-7.191,12.054 c-4.741,4.783-14.436,2.415-14.855,0.264C235.326,384.063,237.986,382.331,241.232,378.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCC6C7"
    },
    d: "M253.02,375.255c-1.354,2.513-2.542,4.725-4.874,6.465c-2.917,2.177-8.239,4.286-11.131,1.439 c-0.952,1.072-1.473,2.016-1.27,3.055c0.42,2.151,10.114,4.52,14.855-0.264c0.979-0.988,3.802-7.562,7.191-12.054 c1.281-1.7,1.223-3.134,0.803-4.318C256.789,371.443,254.336,372.815,253.02,375.255z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#683C11"
    },
    d: "M282.65,378.436c0,0-5.77-4.96-6.781-7.806c-1.012-2.845-0.089-4.198-2.594-3.946 c-3.576,3.278-6.631-0.938-6.631-0.938c0.443,1.315-3.435,3.797-0.556,7.613c3.389,4.494,6.212,11.067,7.192,12.056 c4.74,4.784,14.436,2.415,14.855,0.265C288.557,383.527,285.896,381.796,282.65,378.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCC6C7"
    },
    d: "M270.86,374.721c1.355,2.513,2.544,4.725,4.876,6.464c2.916,2.177,8.238,4.287,11.13,1.439 c0.952,1.074,1.473,2.016,1.27,3.057c-0.42,2.15-10.115,4.52-14.855-0.265c-0.98-0.988-3.804-7.561-7.192-12.056 c-1.282-1.699-1.223-3.132-0.803-4.318C267.092,370.909,269.545,372.28,270.86,374.721z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DC9975"
    },
    points: "238.33,277.619 241.092,274.847 240.322,272.163 236.512,276.838 237.109,284.316  238.074,284.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DC9975"
    },
    points: "239.803,275.74 237.861,276.379 238.46,283.857 239.423,283.992  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DC9975"
    },
    points: "239.404,276.605 238.081,277.541 240.27,283.06 241.031,282.94  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M242.172,235.399c0.328,5.561-1.539,32.559-1.539,32.559l2.11,5.576l0.695,4.297l-1.962-0.248 l-1.721-4.17l-2.213,3.571l-0.842,7.389l-0.856-0.329l-0.87-7.764l-0.051-6.483l-1.104-23.71c0,0-0.479-8.537,0.409-9.986 c-0.11-3.574-0.99-17.571-0.99-17.571l9.433-0.624C242.671,217.905,241.727,227.847,242.172,235.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M242.671,217.905l-9.526,0.08c0,0,0.17,4.264,0.41,5.701c3.619,0.12,4.526,2.148,5.76,5.684 c0.82,2.35,1.961,6.74-2.281,7.598c5.108,3.664,1.979,16.004,1.736,21.816c-0.148,3.596,1.62,9.211,1.863,9.174 c0.387-5.74,1.822-27.734,1.539-32.559C241.727,227.847,242.671,217.905,242.671,217.905z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DC9975"
    },
    points: "285.569,277.619 282.808,274.847 283.578,272.163 287.39,276.838 286.791,284.316  285.826,284.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DC9975"
    },
    points: "284.097,275.74 286.039,276.379 285.441,283.857 284.478,283.992  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DC9975"
    },
    points: "284.498,276.605 285.818,277.541 283.631,283.06 282.871,282.94  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BB8D"
    },
    d: "M281.728,235.399c-0.326,5.561,1.538,32.559,1.538,32.559l-2.108,5.576l-0.695,4.297l1.961-0.248 l1.722-4.17l2.213,3.571l0.841,7.389l0.857-0.329l0.871-7.764l0.049-6.483l1.105-23.71c0,0,0.478-8.537-0.409-9.986 c0.108-3.574,0.99-17.571,0.99-17.571l-9.433-0.624C281.23,217.905,282.174,227.847,281.728,235.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M281.23,217.905l9.525,0.08c0,0-0.17,4.264-0.41,5.701c-3.619,0.12-4.527,2.148-5.76,5.684 c-0.82,2.35-1.961,6.74,2.28,7.598c-5.107,3.664-1.978,16.004-1.735,21.816c0.15,3.596-1.932,4.434-2.178,4.397 c-0.385-5.74-1.508-22.957-1.225-27.781C282.174,227.847,281.23,217.905,281.23,217.905z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49819"
    },
    d: "M243.732,216.857v6.179c0,0-10.848,1.671-11.922,0c-1.076-1.673-0.156-22.574,9.249-26.964 C246.636,193.47,243.732,216.857,243.732,216.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#B5DCD3"
    },
    d: "M233.004,214.548c5.555-2.746,7.053-9.68,6.925-16.256 C235.863,201.793,233.836,208.759,233.004,214.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D9"
    },
    d: "M242.768,213.747c-2.393,3.336-7.219,7.199-11.307,6.637c0.023,1.383,0.152,2.344,0.35,2.652 c1.074,1.671,11.922,0,11.922,0v-6.179c0,0,0.3-2.429,0.523-5.63C243.814,212.129,243.32,212.98,242.768,213.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49819"
    },
    d: "M279.85,216.857v6.179c0,0,10.848,1.671,11.922,0c1.076-1.673,0.157-22.574-9.248-26.964 C276.945,193.47,279.85,216.857,279.85,216.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#B5DCD3"
    },
    d: "M290.578,214.548c-5.556-2.746-7.053-9.68-6.926-16.256 C287.719,201.793,289.744,208.759,290.578,214.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D9"
    },
    d: "M280.813,213.747c2.395,3.336,7.221,7.199,11.309,6.637c-0.023,1.383-0.152,2.344-0.35,2.652 c-1.074,1.671-11.922,0-11.922,0v-6.179c0,0-0.301-2.429-0.523-5.63C279.767,212.129,280.264,212.98,280.813,213.747z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M319.063,213.518c0,0-1.748,1.86-1.855,7.43c-0.039,2.054-6.543,0.621-6.543-1.061 c0-2.302-1.506-17.299,6.291-21.043C321.579,196.622,319.063,213.518,319.063,213.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F2A11"
    },
    d: "M352.38,166.236c-0.018,3.01,0.639,10.197-1.22,23.638c-1.859,13.439-12.875,33.6-17.063,33.6 c-4.185,0-17.778-11.035-17.778-38.241c0-7.057,0.288-14.09-0.504-17.642c-2.776-12.463,6.665-24.286,16.761-24.286 c4.596,0,10.328,0.872,13.039,5.475C351.864,150.772,354.105,158.861,352.38,166.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0DDD0"
    },
    d: "M345.674,199.866c-4.69,6.059-25.358,0.118-25.358,0.118s-4.354-19.402,0-25.807 c4.354-6.405,27.087-1.568,27.087-1.568S350.366,193.809,345.674,199.866z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BD3A4B"
    },
    points: "342.523,381.892 344.695,388.505 337.44,381.804 337.537,376.285 342.62,376.375  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D84B58"
    },
    d: "M354.928,382.841l-16.008-12.686c0.443,1.311-3.432,3.797-0.554,7.611 c3.388,4.495,6.212,11.067,7.191,12.056c4.74,4.782,14.437,2.415,14.855,0.264C360.832,387.933,357.113,385.582,354.928,382.841z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M338.92,370.154c0,0,5.467,11.909,7.537,14.38c2.072,2.471,11.756,2.428,8.471-1.693 c-3.288-4.12-10.039-12.582-10.039-12.582s3.52-49.102,4.107-62.806c0.412-9.619-0.357-32.055-0.357-32.055l-13.136,0.982 c0,0,3.224,23.38,3.131,31.082C334.406,315.231,339.095,342.503,338.92,370.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M347.487,383.66c-1.154-2.119-2.929-8.07-5.013-11.548c-0.697-1.164,1.31-1.872,1.31-1.872 c0.008-1.204-2.449-2.45-2.467-3.651c-0.256-18.793-3.262-37.037-3.014-48.656c0.1-4.693,3.167-8.261,4.33-10.4 c0.02-1.554-2.609-4.167-2.314-6.669c0.798-6.745,8.755-5.434,8.755-5.434l-0.426-19.661c-0.005-0.232-0.012-0.37-0.012-0.37 l-13.136,0.982c0,0,3.224,23.38,3.131,31.082c-4.228,7.769,0.461,35.04,0.286,62.691c0,0,5.467,11.909,7.537,14.38 c1.162,1.384,4.711,1.98,7.03,1.51C352.186,385.777,348.629,385.758,347.487,383.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M356.665,386.581c-0.017,0.875-0.773,3.551-3.681,3.5c-2.909-0.053-6.881-2.42-6.865-3.298 c0.016-0.876,3.05,0.563,5.959,0.613C354.986,387.448,356.68,385.704,356.665,386.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEADB"
    },
    d: "M347.017,326.393c-0.176,9.917-2.038,24.173-2.038,24.173s0.468-14.281,0.644-24.198 c0.176-9.915,1.797-12.847,1.797-12.847S347.193,316.478,347.017,326.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B32A43"
    },
    points: "325.825,381.892 323.652,388.505 330.908,381.803 330.809,376.285 325.727,376.375  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA3D50"
    },
    d: "M313.422,382.841l16.004-12.688c-0.441,1.314,3.436,3.797,0.557,7.612 c-3.389,4.493-6.213,11.067-7.193,12.056c-4.74,4.783-14.436,2.415-14.854,0.264 C307.515,387.933,311.234,385.582,313.422,382.841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M329.426,370.153c0,0-5.465,11.91-7.535,14.381c-2.072,2.471-11.756,2.426-8.469-1.693 c3.285-4.12,10.037-12.582,10.037-12.582s-3.521-49.102-4.107-62.806c-0.412-9.619,0.357-32.056,0.357-32.056l13.137,0.983 c0,0-3.224,23.38-3.131,31.082C333.941,315.231,329.252,342.503,329.426,370.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M320.861,383.66c1.154-2.121,2.927-8.07,5.011-11.548c0.7-1.164-1.31-1.872-1.31-1.872 c-0.008-1.204,2.451-2.45,2.465-3.651c0.258-18.793,3.265-37.037,3.016-48.658c-0.1-4.692-3.167-8.259-4.33-10.398 c-0.017-1.554,2.609-4.168,2.315-6.669c-0.799-6.745-8.757-5.434-8.757-5.434l0.427-19.661c0.008-0.232,0.012-0.371,0.012-0.371 l13.137,0.983c0,0-3.224,23.38-3.131,31.082c4.227,7.769-0.463,35.04-0.289,62.69c0,0-5.465,11.91-7.535,14.381 c-1.162,1.384-4.71,1.979-7.029,1.51C316.162,385.777,319.719,385.758,320.861,383.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.684,386.581c0.016,0.875,0.771,3.551,3.68,3.5c2.908-0.053,6.881-2.422,6.864-3.298 c-0.015-0.876-3.049,0.563-5.958,0.613C313.361,387.449,311.668,385.704,311.684,386.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEADB"
    },
    d: "M321.33,326.393c0.178,9.917,2.039,24.172,2.039,24.172s-0.467-14.281-0.645-24.197 c-0.176-9.915-1.797-12.847-1.797-12.847S321.154,316.478,321.33,326.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8254"
    },
    points: "309.177,279.726 312.228,277.277 311.763,274.524 307.455,278.747 307.217,286.245  308.159,286.485  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8254"
    },
    points: "310.85,278.022 308.848,278.442 308.607,285.938 309.553,286.181  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8254"
    },
    points: "310.355,278.839 308.938,279.618 310.496,285.351 311.266,285.313  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M317.695,238.196c-0.295,5.563-5.401,33.55-5.401,33.55l1.722,4.411l-0.188,3.838l-1.521,0.045 l-1.246-4.336l-2.598,3.302l-1.659,7.249l-0.814-0.421l0.646-8.848l1.832-5.849l1.304-24.517c0,0,0.443-6.903,1.484-8.246 c0.289-3.564-0.592-18.488-0.592-18.488l6.44-0.179C317.104,219.708,318.096,230.641,317.695,238.196z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M318.83,213.835l-0.381-3.039c0,0-5.193,1.76-3.127,17.197c0.332,2.466,1.404,10.81-2.908,11.19 c4.668,4.21,0.184,16.125-0.704,21.872c-0.549,3.557,0.584,9.335,0.831,9.325c1.022-5.662,4.9-27.358,5.154-32.184 c0.284-5.357-0.087-12.414-0.398-16.063C316.825,216.582,318.83,213.835,318.83,213.835z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#259DAB"
    },
    d: "M350.676,326.637c0,0-5.105,2.929-16.111,2.941c-12.416,0.017-16.545-2.941-16.545-2.941 s-5.113-60.753-4.859-67.438c0.255-6.688,2.72-10.967,2.72-10.967l8.652-1.027l19.936-0.163l7.041,0.835 c0,0,2.084,4.676,1.824,10.52C353.072,264.239,350.676,326.637,350.676,326.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D9"
    },
    d: "M325.975,317.989c-4.078-6.328-12.824-35.124-2.865-51.571c3.913-6.462,9.117-10.331,15.067-14.532 c2.368-1.674,10.205-1.99,12.375-4.123l-6.083-0.722l-19.936,0.163l-8.652,1.027c0,0-2.465,4.279-2.72,10.967 c-0.254,6.686,4.859,67.438,4.859,67.438s8.834,4.161,20.732,2.787C341.789,329.07,331.489,326.549,325.975,317.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#B5DCD3"
    },
    d: "M332.622,280.807c1.64-5.299,3.992-9.71,5.692-14.925 c0.467-1.439,0.805-2.807,1.023-4.116c-1.352,2.061-2.836,3.963-4.199,5.717c-4.834,6.227-7.973,14.207-6.093,25.41 c0.792,4.725,2.007,8.791,3.913,12.067C331.008,297.09,330.289,288.352,332.622,280.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#259DAB"
    },
    d: "M352.438,247.876c0,0-3.762,5.527-18.108,5.35c-14.345-0.18-18.934-4.008-18.934-4.008 l5.839-16.141l-2.066-16.537l-0.67-18.345l5.592-2.343l20.947-0.162l4.6,2.505l-0.667,18.345l-2.127,15.289L352.438,247.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDE7CA"
    },
    d: "M319.944,236.645c0,0,2.612,1.832,13.052,1.832c10.439,0,15.525-1.832,15.525-1.832l-1.679-4.815 l0.546-3.92c0,0-6.963,1.831-13.68,1.831s-13.121-1.831-13.121-1.831l0.647,5.168L319.944,236.645z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D4D6D9"
    },
    points: "347.216,232.901 346.843,231.829 346.996,230.722 336.749,231.607  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M319.168,216.54l-2.213-17.696c0,0,0.768-0.322,1.543-0.648 C323.109,215.647,319.168,216.54,319.168,216.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M349.072,213.518c0,0,1.75,1.86,1.855,7.43c0.04,2.054,6.543,0.621,6.543-1.061 c0-2.302,1.506-17.299-6.29-21.043C347.555,197.061,349.072,213.518,349.072,213.518z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8254"
    },
    points: "358.959,279.726 355.906,277.277 356.373,274.524 360.682,278.747 360.92,286.245  359.977,286.485  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8254"
    },
    points: "357.286,278.022 359.289,278.442 359.527,285.938 358.584,286.181  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8254"
    },
    points: "357.781,278.839 359.199,279.618 357.639,285.351 356.87,285.313  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M350.44,238.196c0.294,5.563,5.401,33.55,5.401,33.55l-1.723,4.411l0.188,3.838l1.522,0.045 l1.247-4.336l2.596,3.302l1.66,7.249l0.814-0.421l-0.647-8.848l-1.831-5.849l-1.303-24.517c0,0-0.443-6.903-1.484-8.246 c-0.291-3.564,0.59-18.488,0.59-18.488l-6.44-0.179C351.031,219.708,350.041,230.641,350.44,238.196z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M349.306,213.835l0.382-3.039c0,0,5.191,1.76,3.125,17.197c-0.33,2.466-1.403,10.81,2.908,11.19 c-4.668,4.21-0.183,16.125,0.705,21.872c0.549,3.557-0.584,9.335-0.83,9.325c-1.023-5.662-4.9-27.358-5.155-32.184 c-0.284-5.357,0.086-12.414,0.397-16.063C351.31,216.582,349.306,213.835,349.306,213.835z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D9"
    },
    d: "M328.538,250.146c-6.267-4.475-2.458-9.825-4.983-16.67c-1.809-4.908-0.729-4.679-1.16-9.628 c-0.133-1.561-2.213-4.834-3.077-6.1l1.917,15.328l-5.839,16.141c0,0,4.59,3.828,18.934,4.008 C340.916,253.306,331.016,251.915,328.538,250.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M324.09,195.852c0,0,1.044,17.185,10.039,17.185c8.994,0,10.908-17.347,10.908-17.347l-5.715-1.59 l0.652-9.613h-11.693l1.177,9.347L324.09,195.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M329.685,206.954c-3.422-5.572-0.232-11.896,2.641-13.732c3.244-2.071,6.538-2.832,6.527-7.465 c-0.002-0.429-0.025-0.849-0.047-1.27h-10.525l1.177,9.347l-5.368,2.018c0,0,0.914,17.185,10.039,17.185 c2.977,0.335,5.266-2.462,5.266-2.462S333.516,213.193,329.685,206.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M339.635,189.651l0.34-5.164h-11.437l0.415,5.097c0,0,3.389,3.518,6.607,3.153 C338.779,192.372,339.635,189.651,339.635,189.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M348.887,166.73c0.196,2.511-0.357,8.7-0.746,10.992c-1.051,6.234-10.653,13.262-14.037,13.262 c-3.387,0-11.357-6.793-13.709-11.861c-1.145-2.466-1.077-8.213-1.077-11.258c0-12.688,6.62-20.327,14.786-20.327 C342.267,147.537,347.713,151.77,348.887,166.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M327.52,174.518c0.139-1.079,0.359-2.143,0.646-3.191c0.109-0.553,0.242-1.104,0.4-1.654 c0.193-1.197,0.528-2.385,1.025-3.54c1.349-3.132,3.227-5.934,5.47-8.267c2.337-2.842,5.047-5.368,7.97-7.662 c-2.37-1.915-5.311-2.667-8.736-2.667c-8.271,0-14.978,7.635-14.978,20.313c0,3.046-0.034,8.772,1.091,11.254 c2.444,5.384,10.455,11.855,13.887,11.855c0.028,0,0.066-0.01,0.1-0.01C329.186,187.448,326.59,181.751,327.52,174.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M322.85,171.792c0,2.449-0.57,3.444-2.68,4.152c-3.307,1.108-3.918-2.867-4.84-5.188 c-0.975-2.453,1.78-8.577,5.4-1.868C323,168.889,322.85,169.343,322.85,171.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M322.85,171.792c0,2.449-0.57,3.444-2.68,4.152c-3.307,1.108-3.918-2.867-4.84-5.188 c-0.975-2.453,1.78-8.577,5.4-1.868C323,168.889,322.85,169.343,322.85,171.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M344.693,171.792c0,2.449,0.572,3.444,2.69,4.152c3.316,1.108,3.931-2.867,4.854-5.188 c0.978-2.453-1.786-8.577-5.417-1.868C344.544,168.889,344.693,169.343,344.693,171.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F2A11"
    },
    d: "M345.342,150.772c0.059,0.118,3.294,4.914,4.104,10.952c0.59,4.399-1.085,10.539-1.438,10.701 c0.746-8.712-5.602-12.569-5.55-19.935c-1.061,1.961-4.255,5.027-8.336,7.345c-6.747,3.835-8.265,3.133-11.738,7.224 c-2.751,3.241,2.076,35.635,1.44,35.825c-1.075,0.325-7.801-23.345-7.137-36.682c0.586-11.736,0.365-9.947,9.044-16.799 C335.189,141.936,344.681,149.413,345.342,150.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0DDD0"
    },
    d: "M321.131,156.71c8.174-3.254,8.387-0.587,16.453-3.254c2.469-0.816,6.156-4.727,6.914-5.089 c-7.957-6.285-14.003-5.826-20.153-0.97c-5.297,4.183-8.321,11.4-7.532,15.813C317.791,160.155,319.481,157.366,321.131,156.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0DDD0"
    },
    d: "M347.389,162.133c-1.049-2.538-2.424-4.671-2.877-7.405c-0.191-1.154-0.119-5.188-2.882-2.82 c-0.815,0.707-1.642,1.406-2.476,2.091c-1.39,1.092-2.789,2.272-4.354,3.109c-4.607,2.466-13.203,4.02-15.483,10.757 c-2.278,6.734,0.48,16.623,0.48,16.623s-2.006-12.353,1.396-17.568c2.93-4.494,6.182-3.248,12.929-7.083 c4.081-2.317,7.275-5.384,8.336-7.345c-0.044,6.368,4.686,10.121,5.488,16.647C348.313,166.767,348.307,164.357,347.389,162.133z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B53E60"
    },
    d: "M338.458,181.417c0,0-0.909,2.449-4.3,2.449c-2.748,0-3.879-2.449-3.879-2.449 s2.43-0.483,3.309-0.483c0.37,0.586,0.928,0.483,1.318,0C335.866,180.934,338.458,181.417,338.458,181.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A23856"
    },
    d: "M338.458,181.417c0,0-1.13,0.645-4.154,0.645c-2.663,0-4.025-0.645-4.025-0.645 s2.43-0.483,3.309-0.483c0.37,0.586,0.928,0.483,1.318,0C335.866,180.934,338.458,181.417,338.458,181.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M335.4,182.315c0,0.157-0.514,0.599-1.148,0.599s-1.148-0.441-1.148-0.599 c0-0.158,0.514,0.027,1.148,0.027S335.4,182.157,335.4,182.315z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M333.933,166.919c0,0,0.075,6.648-0.07,6.692c0.218,0.067,0.421,0.183,0.597,0.334 c0.403,0.346,0.664,0.888,0.664,1.499c0,0.876-0.537,1.607-1.261,1.83c0.146,0.045,0.297,0.077,0.456,0.077 c0.948,0,1.717-0.855,1.717-1.907c0-0.953-0.628-1.743-1.449-1.887C334.5,173.543,333.933,166.919,333.933,166.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F2A11"
    },
    d: "M345.953,166.203c0,0-1.301-1.695-4.791-1.19c-0.897,0.131-1.786,0.971-1.786,0.506 c0-0.463,0.736-1.61,1.64-1.68C344.25,163.591,345.953,166.203,345.953,166.203z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M341.523,173.997c0,0.223-0.295,0.403-0.662,0.403s-0.662-0.181-0.662-0.403 c0-0.225,0.295-0.405,0.662-0.405S341.523,173.771,341.523,173.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M343.148,174.331c0,0.139-0.219,0.25-0.486,0.25c-0.265,0-0.48-0.111-0.48-0.25 c0-0.139,0.216-0.25,0.48-0.25C342.93,174.081,343.148,174.192,343.148,174.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M344.98,174.081c0,0.139-0.217,0.25-0.483,0.25s-0.483-0.111-0.483-0.25 c0-0.138,0.217-0.249,0.483-0.249S344.98,173.943,344.98,174.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M342.008,174.989c0,0.06-0.14,0.11-0.313,0.11c-0.172,0-0.311-0.051-0.311-0.11 c0-0.061,0.139-0.111,0.311-0.111C341.868,174.878,342.008,174.928,342.008,174.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M345.554,173.589c0,0.063-0.103,0.111-0.226,0.111c-0.125,0-0.225-0.049-0.225-0.111 c0-0.06,0.1-0.108,0.225-0.108C345.451,173.48,345.554,173.529,345.554,173.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M342.889,175.429c0,0.063-0.101,0.111-0.227,0.111c-0.123,0-0.224-0.049-0.224-0.111 c0-0.06,0.101-0.109,0.224-0.109C342.788,175.319,342.889,175.369,342.889,175.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M343.816,174.69c0,0.063-0.141,0.111-0.313,0.111c-0.17,0-0.311-0.049-0.311-0.111 c0-0.061,0.141-0.109,0.311-0.109C343.676,174.581,343.816,174.63,343.816,174.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M343.459,173.589c0,0.063-0.141,0.111-0.31,0.111c-0.174,0-0.314-0.049-0.314-0.111 c0-0.06,0.14-0.108,0.314-0.108C343.318,173.48,343.459,173.529,343.459,173.589z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#683C11"
    },
    d: "M342.008,169.696c0,0.799-0.532,1.447-1.188,1.447c-0.656,0-1.186-0.648-1.186-1.447 c0-0.799,0.529-1.447,1.186-1.447C341.475,168.249,342.008,168.897,342.008,169.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M340.838,169.089c0,0.273-0.224,0.494-0.496,0.494c-0.274,0-0.496-0.221-0.496-0.494 c0-0.274,0.222-0.496,0.496-0.496C340.614,168.593,340.838,168.814,340.838,169.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.051,169.616c0,0.141-0.112,0.254-0.253,0.254c-0.14,0-0.251-0.113-0.251-0.254 c0-0.139,0.111-0.25,0.251-0.25C340.938,169.366,341.051,169.477,341.051,169.616z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M342.685,172.583c1.15,0,2.188,0.212,2.988,0.549c-0.615-0.626-1.711-1.047-2.976-1.047 c-1.254,0-2.347,0.416-2.964,1.03C340.53,172.789,341.553,172.583,342.685,172.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F2A11"
    },
    d: "M323.198,166.203c0,0,1.302-1.695,4.79-1.19c0.898,0.131,1.787,0.971,1.787,0.506 c0-0.463-0.736-1.61-1.641-1.68C324.902,163.591,323.198,166.203,323.198,166.203z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M327.627,173.997c0,0.223,0.297,0.403,0.664,0.403c0.365,0,0.662-0.181,0.662-0.403 c0-0.225-0.297-0.405-0.662-0.405C327.924,173.592,327.627,173.771,327.627,173.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M326.005,174.331c0,0.139,0.218,0.25,0.484,0.25c0.265,0,0.482-0.111,0.482-0.25 c0-0.139-0.218-0.25-0.482-0.25C326.223,174.081,326.005,174.192,326.005,174.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M324.17,174.081c0,0.139,0.218,0.25,0.484,0.25c0.268,0,0.482-0.111,0.482-0.25 c0-0.138-0.215-0.249-0.482-0.249C324.388,173.832,324.17,173.943,324.17,174.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M327.145,174.989c0,0.06,0.139,0.11,0.31,0.11c0.172,0,0.313-0.051,0.313-0.11 c0-0.061-0.141-0.111-0.313-0.111C327.283,174.878,327.145,174.928,327.145,174.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M323.6,173.589c0,0.063,0.1,0.111,0.225,0.111c0.124,0,0.226-0.049,0.226-0.111 c0-0.06-0.102-0.108-0.226-0.108C323.7,173.48,323.6,173.529,323.6,173.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M326.264,175.429c0,0.063,0.1,0.111,0.226,0.111c0.124,0,0.224-0.049,0.224-0.111 c0-0.06-0.1-0.109-0.224-0.109C326.363,175.319,326.264,175.369,326.264,175.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M325.335,174.69c0,0.063,0.141,0.111,0.311,0.111c0.173,0,0.312-0.049,0.312-0.111 c0-0.061-0.139-0.109-0.312-0.109C325.475,174.581,325.335,174.63,325.335,174.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M325.693,173.589c0,0.063,0.139,0.111,0.311,0.111c0.173,0,0.312-0.049,0.312-0.111 c0-0.06-0.139-0.108-0.312-0.108C325.832,173.48,325.693,173.529,325.693,173.589z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#683C11"
    },
    d: "M327.145,169.696c0,0.799,0.531,1.447,1.188,1.447c0.654,0,1.185-0.648,1.185-1.447 c0-0.799-0.531-1.447-1.185-1.447C327.676,168.249,327.145,168.897,327.145,169.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.315,169.089c0,0.273,0.223,0.494,0.496,0.494c0.272,0,0.493-0.221,0.493-0.494 c0-0.274-0.221-0.496-0.493-0.496C328.538,168.593,328.315,168.814,328.315,169.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.1,169.616c0,0.141,0.113,0.254,0.252,0.254c0.141,0,0.253-0.113,0.253-0.254 c0-0.139-0.112-0.25-0.253-0.25C328.214,169.366,328.1,169.477,328.1,169.616z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M326.467,172.583c-1.149,0-2.188,0.212-2.99,0.549c0.615-0.626,1.713-1.047,2.978-1.047 c1.254,0,2.345,0.416,2.963,1.03C328.623,172.789,327.6,172.583,326.467,172.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0DDD0"
    },
    d: "M345.103,151.175c0,0,0.441,4.546,1.686,6.82c1.242,2.274,4.453,5.828,4.453,5.828 s0.803-7.434-0.803-9.705c-1.605-2.273-4.486-3.879-4.486-3.879L345.103,151.175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M348.97,216.54l2.211-17.696c0,0-0.767-0.322-1.544-0.648 C345.025,215.647,348.97,216.54,348.97,216.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D9"
    },
    d: "M340.072,233.726c0,0-3.053,0.88-6.818,0.88c-3.768,0-6.822-0.88-6.822-0.88s3.055,0,6.822,0 C337.02,233.726,340.072,233.726,340.072,233.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D9"
    },
    d: "M348.203,235.931c0,0-3.055,1.346-6.819,1.346c-3.767,0-7.469,0-7.469,0s3.702-0.883,7.469-0.883 C345.148,236.393,348.203,235.931,348.203,235.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D9"
    },
    d: "M331.354,230.938c0,0-1.972,0.673-4.284,0.42c-2.312-0.251-4.091-1.331-4.091-1.331 s1.875,0.203,4.189,0.456C329.479,230.733,331.354,230.938,331.354,230.938z"
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.857,229.931c-0.378,6.118-1.389,11.248-3.236,13.987c-3.433,5.089-8.932,0.76-11.042,0.858 c-2.281,0.105-8.094,2.735-10.894-0.779c-1.98-2.485-3.426-7.117-3.093-13.648c-2.159-9.682,5.175-18.865,13.019-18.865 c3.572,0,8.025,0.677,10.129,4.254C311.596,217.283,313.197,224.202,311.857,229.931z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M320.248,272.091c-1.469-2.357-5.666-10.788-5.666-10.788l-5.441,2.315 c0,0,4.193,10.672,8.807,14.227C320.09,279.493,321.377,275.673,320.248,272.091z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B97947"
    },
    points: "278.045,314.227 280.495,312.425 280.224,310.273 276.74,313.411 276.314,319.222  277.038,319.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B97947"
    },
    points: "279.399,312.959 277.832,313.219 277.404,319.03 278.129,319.247  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B97947"
    },
    points: "278.99,313.577 277.865,314.136 278.888,318.636 279.487,318.63  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M286.005,282.271c-0.407,4.308-5.28,25.863-5.28,25.863l1.193,3.48l-0.272,2.973l-1.182-0.017 l-0.826-3.404l-2.123,2.478l-1.523,5.574l-0.617-0.354l-0.168-6.165l2.625-6.088l1.135-18.096c0,0,0.429-5.291,1.281-6.296 c0.341-2.759-0.01-14.129-0.01-14.129l5.91-0.189C286.148,267.9,286.56,276.419,286.005,282.271z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M286.148,267.9l-5.005-0.069c0,0,0.013,0.727,0.024,1.857c2.766,0.522,3.67,3.616,3.392,6.436 c-0.189,1.925,0.675,6.588-2.683,6.74c3.485,3.42-0.383,12.523-1.258,16.955c-0.541,2.741,0.15,7.263,0.342,7.264 c0.975-4.363,4.693-21.076,5.044-24.813C286.56,276.419,286.148,267.9,286.148,267.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#55AEA3"
    },
    d: "M309.717,266.487l2.404,3.395c0,0,4.633-3.816,5.326-4.926c0.691-1.107-2.063-11.367-6.009-12.242 C307.547,251.852,309.717,266.487,309.717,266.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D9"
    },
    d: "M313.334,266.917c-2.272-0.229-2.169-1.336-3.523-5.637c0.178,2.167-0.094,5.207-0.094,5.207 l2.404,3.395c0,0,3.439-2.835,4.832-4.327C316.053,265.693,314.18,266.999,313.334,266.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#B5DCD3"
    },
    d: "M316.775,264.229c-3.578-1.817-4.541-6.413-4.46-10.771 C314.934,255.779,316.238,260.396,316.775,264.229z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#432827"
    },
    d: "M289.225,395.153l-11.289,3.35c0,0-0.236,1.604,0.799,2.484c1.034,0.882,3.602,2.491,7.635,0.527 c2.469-1.204,3.677-5.722,3.677-5.722l3.415-3.539l-0.011-2.229l-4.302,0.844L289.225,395.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#583636"
    },
    d: "M287.387,386.116l4.635-0.082c-0.342,1.022,3.067,3.3,0.432,5.914 c-3.228,3.205-4.379,6.385-5.137,7.155c-2.369,2.411-9.053,1.071-9.381-0.601C277.611,396.831,285.695,389.458,287.387,386.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M292.021,386.034c0,0-3.978,2.293-4.635,0.082c-0.074-1.03-2.735-38.14-3.191-48.788 c-0.32-7.472-0.063-28.01-0.063-28.01l11.41,3.108c0,0-3,18.812-2.926,24.795C295.899,343.258,291.887,364.557,292.021,386.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDED"
    },
    d: "M292.143,377.589h-5.36c0.342,4.865,0.582,8.229,0.603,8.527c0.656,2.211,4.635-0.082,4.635-0.082 C292.003,383.204,292.055,380.376,292.143,377.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M289.404,385.641c-0.005-0.935,1.105-0.659,1.119-1.595c0.199-14.598,2.17-29.553,1.978-38.577 c-0.078-3.645-2.462-6.418-3.365-8.078c-0.015-1.208,1.537-3.24,1.799-5.181c2.525-18.673-6.523-17.061-6.523-17.061l0.053-2.433 c0.005-0.182,0.008-0.289,0.008-0.289l10.852,1.474c0,0-2.781,17.338-2.707,23.321c3.282,6.036-0.73,27.335-0.596,48.813 L289.404,385.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M279.125,397.237c0.012,0.682,0.6,2.76,2.859,2.719c2.26-0.039,5.345-1.879,5.332-2.56 c-0.012-0.681-2.369,0.438-4.629,0.476C280.428,397.912,279.112,396.558,279.125,397.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEADB"
    },
    d: "M285.732,352.043c0.137,7.702,1.584,18.776,1.584,18.776s-0.362-11.094-0.499-18.795 c-0.139-7.703-1.397-9.982-1.397-9.982S285.596,344.338,285.732,352.043z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#432827"
    },
    d: "M307.685,395.153l11.286,3.35c0,0,0.24,1.604-0.797,2.484c-1.035,0.882-3.599,2.491-7.633,0.527 c-2.47-1.204-3.678-5.722-3.678-5.722l-3.416-3.539l0.01-2.229l4.303,0.844L307.685,395.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#583636"
    },
    d: "M309.522,386.116l-4.635-0.082c0.343,1.022-3.071,3.3-0.433,5.914 c3.23,3.205,4.381,6.385,5.136,7.155c2.37,2.411,9.054,1.071,9.38-0.601C319.297,396.831,311.215,389.458,309.522,386.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M304.888,386.034c0,0,3.976,2.293,4.635,0.082c0.072-1.03,2.733-38.14,3.19-48.788 c0.32-7.472,0.062-28.01,0.062-28.01l-11.411,3.108c0,0,3.001,18.812,2.929,24.795 C301.008,343.258,305.023,364.557,304.888,386.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDED"
    },
    d: "M304.766,377.589h5.36c-0.343,4.865-0.584,8.229-0.603,8.527 c-0.659,2.211-4.635-0.082-4.635-0.082C304.904,383.204,304.853,380.376,304.766,377.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M307.502,385.641c0.008-0.935-1.103-0.659-1.117-1.595c-0.199-14.598-2.17-29.553-1.979-38.577 c0.076-3.645,2.46-6.418,3.365-8.078c0.014-1.208-1.537-3.24-1.797-5.181c-2.527-18.673,6.522-17.061,6.522-17.061l-0.053-2.433 c-0.003-0.182-0.009-0.289-0.009-0.289l-10.853,1.474c0,0,2.782,17.338,2.71,23.321c-3.284,6.036,0.732,27.335,0.596,48.813 L307.502,385.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.783,397.237c-0.012,0.682-0.598,2.76-2.858,2.719c-2.26-0.039-5.346-1.879-5.335-2.56 c0.013-0.681,2.37,0.438,4.63,0.476C316.48,397.912,317.795,396.558,317.783,397.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEEADB"
    },
    d: "M311.176,352.043c-0.137,7.702-1.585,18.776-1.585,18.776s0.364-11.094,0.501-18.795 c0.137-7.703,1.396-9.982,1.396-9.982S311.313,344.338,311.176,352.043z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#55AEA3"
    },
    d: "M286.199,266.487v4.094c0,0-6.985,1.107-7.677,0c-0.694-1.107-0.103-14.957,5.954-17.867 C288.068,250.989,286.199,266.487,286.199,266.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#B5DCD3"
    },
    d: "M279.291,264.956c3.578-1.818,4.541-6.413,4.459-10.771 C281.133,256.506,279.826,261.12,279.291,264.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D9"
    },
    d: "M285.578,264.427c-1.539,2.209-4.65,4.769-7.281,4.399c0.014,0.915,0.096,1.55,0.226,1.755 c0.691,1.107,7.677,0,7.677,0v-4.094c0,0,0.193-1.608,0.336-3.73C286.252,263.353,285.934,263.919,285.578,264.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#352E35"
    },
    d: "M310.369,374.108h-5.768l-5.91-61.275l-1.267-0.305c0,0-4.429,59.688-5.054,60.304 c-2.91,2.868-5.836,0-5.836,0s-4.773-45.089-4.119-72.269c0.125-5.196,1.967-9.806,1.967-9.806l5.981-0.477l15.485-0.126 l5.471,0.647c0,0,0.57,2.745,1.416,8.172C316.017,320.064,310.369,374.108,310.369,374.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C6C6"
    },
    d: "M304.361,357.24c-1.244-8.003-0.903-16.043-1.416-24.097c-0.222-3.502-0.604-6.994-0.908-10.492 c-0.122-1.426-2.536-14.396-5.972-9.161c-0.448,0.688-4.618,4.189-6.591,16.448c-0.923,5.747-1.07,11.561-1.244,17.389 c-0.227,7.527-0.395,15.075-2.016,22.341c0.199,2.023,0.32,3.164,0.32,3.164s2.926,2.868,5.836,0 c0.625-0.616,5.054-60.304,5.054-60.304l1.267,0.305l5.91,61.275h5.768c0,0,0.101-0.967,0.268-2.691 C306.213,368.089,305.184,362.531,304.361,357.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C6C6"
    },
    d: "M288.667,302.199c21.874,0,23.655-5.513,22.926-9.984c-0.089-0.48-0.157-0.839-0.205-1.071 c-0.022-0.115-0.047-0.228-0.073-0.342l-5.465-0.646l-15.485,0.126l-5.981,0.477c0,0-1.842,4.609-1.967,9.806 c-0.092,3.825-0.076,8.01,0.02,12.372C282.559,318.591,284.723,302.199,288.667,302.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#55AEA3"
    },
    d: "M312.881,296.889c0,0-3.951,3.328-15.095,3.19c-11.146-0.14-15.096-3.19-15.096-3.19l3.604-16.009 l-1.818-28.166l5.544-2.322l16.271-0.125l5.017,2.447l-2.479,25.698L312.881,296.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D6D9"
    },
    d: "M291.392,295.065c-3.912-6.934,0.079-12.366,5.428-17.451c-9.344,0-11.022-12.891-11.693-13.875 l1.168,17.141l-3.604,16.009c0,0,2.989,3.032,14.13,3.171c5.118,0.063,11.195-0.807,13.361-1.766 C307.612,298.619,293.276,298.407,291.392,295.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M290.021,250.392c0,0-1.319,8.452,7.797,8.452c9.355,0,8.475-8.577,8.475-8.577l-4.439-1.236 l0.507-7.469h-9.083l0.914,7.26L290.021,250.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M295.385,255.188c-1.005-2.067-1.199-5.414,1.033-6.841c2.521-1.608,5.078-2.201,5.068-5.799 c0-0.331-0.018-0.659-0.034-0.986h-8.176l0.914,7.26l-4.17,1.57c0,0-1.319,8.452,7.797,8.452c0.56,0,1.081-0.033,1.569-0.091 C297.732,258.194,296.277,257.028,295.385,255.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M302.104,245.306l0.255-3.744h-9.083l0.485,3.952c0,0,2.668,2.74,5.168,2.456 C301.43,247.686,302.104,245.306,302.104,245.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M309.281,229.679c0.154,1.951-0.258,6.764-0.576,8.539c-1.052,5.836-8.262,8.47-10.892,8.47 c-2.63,0-8.556-2.213-10.663-7.382c-0.799-1.956-0.835-6.38-0.835-8.745c0-9.856,5.142-15.79,11.481-15.79 C304.141,214.77,308.37,218.059,309.281,229.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M292.422,235.741c0.11-0.838,0.283-1.665,0.514-2.479c0.085-0.431,0.191-0.858,0.315-1.288 c0.153-0.929,0.419-1.853,0.814-2.752c1.073-2.433,2.565-4.611,4.343-6.423c1.856-2.209,4.007-4.174,6.326-5.956 c-1.88-1.489-4.216-2.073-6.936-2.073c-6.564,0-11.887,5.934-11.887,15.79c0,2.365,0.434,6.779,1.24,8.745 c2.803,6.842,10.638,7.382,10.663,7.382C293.681,243.967,291.682,241.364,292.422,235.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M289.057,233.61c0,1.902-0.442,2.678-2.082,3.229c-2.57,0.86-3.044-2.229-3.759-4.032 c-0.757-1.905,1.382-6.663,4.194-1.45C289.173,231.356,289.057,231.709,289.057,233.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M289.057,233.61c0,1.902-0.442,2.678-2.082,3.229c-2.57,0.86-3.044-2.229-3.759-4.032 c-0.757-1.905,1.382-6.663,4.194-1.45C289.173,231.356,289.057,231.709,289.057,233.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M306.025,233.61c0,1.902,0.443,2.678,2.088,3.229c2.578,0.86,3.053-2.229,3.772-4.032 c0.76-1.905-1.387-6.663-4.207-1.45C305.909,231.356,306.025,231.709,306.025,233.61z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M306.529,217.283c0.044,0.092,2.559,3.817,3.188,8.507c0.457,3.42-0.844,8.188-1.117,8.314 c0.579-6.767-4.35-9.765-4.311-15.485c-0.825,1.524-3.307,3.906-6.476,5.706c-5.241,2.979-6.423,2.433-9.12,5.61 c-2.136,2.52-0.965,5.374-1.459,5.523c-0.834,0.251-1.477-6.283-1.61-6.555c-0.514-1.056-1.071-7.36,5.671-12.682 C298.642,210.421,306.014,216.227,306.529,217.283z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282727"
    },
    d: "M287.721,221.895c6.352-2.527,6.517-0.455,12.783-2.527c1.916-0.633,4.781-3.672,5.369-3.952 c-6.182-4.884-10.877-4.526-15.654-0.753c-4.115,3.246-6.464,8.854-5.851,12.283C285.127,224.573,286.441,222.405,287.721,221.895 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282727"
    },
    d: "M308.116,226.108c-0.814-1.971-1.882-3.628-2.232-5.752c-0.148-0.896-0.092-4.029-2.239-2.191 c-0.634,0.549-1.276,1.091-1.923,1.625c-1.08,0.848-2.168,1.764-3.382,2.415c-3.581,1.915-11.56,2.935-12.571,7.56 c0.263,1.827,0.803,5.893,1.465,5.692c0.494-0.148-0.677-3.003,1.459-5.523c2.697-3.178,3.879-2.631,9.12-5.61 c3.169-1.8,5.65-4.182,6.476-5.706c-0.035,4.947,3.64,7.863,4.263,12.934C308.838,229.71,308.832,227.837,308.116,226.108z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M301.567,239.101c0,0-0.781,3.311-3.688,3.311c-2.786,0-3.327-3.311-3.327-3.311 s2.085-0.314,2.838-0.314c0.316,0.382,0.795,0.314,1.131,0C299.344,238.786,301.567,239.101,301.567,239.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#983539"
    },
    d: "M301.567,239.101c0,0-0.781,2.222-3.688,2.222c-2.786,0-3.327-2.222-3.327-2.222 s0.879,0.345,3.367,0.345C300.41,239.445,301.567,239.101,301.567,239.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D36563"
    },
    d: "M299.791,239.37c-0.512,0.044-1.124,0.075-1.871,0.075c-0.582,0-1.07-0.019-1.485-0.048 c-0.026,0.039-0.064,0.069-0.087,0.107c-0.26,0.409-0.381,0.852-0.477,1.301c0.485,0.299,1.138,0.517,2.009,0.517 c1.214,0,2.052-0.389,2.624-0.839C300.35,240.032,300.125,239.637,299.791,239.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.736,239.882c0.438-0.087,0.831-0.781,0.831-0.781s-1.157,0.345-3.647,0.345 c-2.488,0-3.367-0.345-3.367-0.345s0.453,0.648,0.717,0.781c0.133,0.064,1.413,0.203,2.678,0.203 C299.607,240.085,300.516,239.923,300.736,239.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M298.943,241.444c0,0.102-0.439,0.391-0.984,0.391c-0.544,0-0.984-0.288-0.984-0.391 c0-0.104,0.44,0.018,0.984,0.018C298.504,241.462,298.943,241.341,298.943,241.444z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M298.06,228.871c0,0,0.058,5.163-0.055,5.198c0.168,0.053,0.326,0.141,0.463,0.258 c0.314,0.27,0.515,0.69,0.515,1.165c0,0.682-0.415,1.249-0.978,1.422c0.112,0.034,0.229,0.06,0.352,0.06 c0.738,0,1.334-0.662,1.334-1.481c0-0.74-0.484-1.353-1.123-1.466C298.5,234.017,298.06,228.871,298.06,228.871z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.614,228.941c0,0-0.599-1.042-3.334-1.185c-1.014-0.053-2.095,0.963-2.06,0.604c0.035-0.358,0.566-1.522,2.033-1.522 C305.773,226.839,306.614,228.941,306.614,228.941z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M303.156,233.681c0,0.173-0.23,0.315-0.516,0.315c-0.282,0-0.513-0.143-0.513-0.315 c0-0.175,0.23-0.315,0.513-0.315C302.926,233.365,303.156,233.506,303.156,233.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M304.418,233.941c0,0.108-0.168,0.192-0.376,0.192c-0.207,0-0.376-0.084-0.376-0.192 c0-0.108,0.169-0.194,0.376-0.194C304.25,233.747,304.418,233.833,304.418,233.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M305.842,233.747c0,0.107-0.168,0.194-0.375,0.194c-0.208,0-0.375-0.088-0.375-0.194 c0-0.108,0.167-0.194,0.375-0.194C305.674,233.553,305.842,233.639,305.842,233.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M303.531,234.451c0,0.047-0.107,0.085-0.24,0.085c-0.135,0-0.243-0.038-0.243-0.085 c0-0.049,0.108-0.086,0.243-0.086C303.424,234.365,303.531,234.402,303.531,234.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M306.285,233.364c0,0.048-0.078,0.086-0.174,0.086c-0.098,0-0.174-0.038-0.174-0.086 c0-0.046,0.076-0.083,0.174-0.083C306.207,233.281,306.285,233.318,306.285,233.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M304.217,234.794c0,0.048-0.078,0.086-0.175,0.086c-0.097,0-0.175-0.038-0.175-0.086 c0-0.046,0.078-0.086,0.175-0.086C304.139,234.708,304.217,234.748,304.217,234.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M304.936,234.22c0,0.049-0.108,0.086-0.241,0.086c-0.135,0-0.242-0.037-0.242-0.086 c0-0.048,0.107-0.086,0.242-0.086C304.828,234.134,304.936,234.172,304.936,234.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M304.659,233.364c0,0.048-0.11,0.086-0.241,0.086c-0.135,0-0.243-0.038-0.243-0.086 c0-0.046,0.108-0.083,0.243-0.083C304.549,233.281,304.659,233.318,304.659,233.364z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M305.523,231.473c0,0-0.517-0.341-2.176-0.169c-0.971,0.102-1.693,0.762-1.758,0.279 c-0.082-0.616,1.063-1.026,2.041-1.026C304.609,230.557,305.523,231.473,305.523,231.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#683C11"
    },
    d: "M305.523,231.473c0,0-0.641-0.608-2.301-0.436c-0.973,0.099-1.645,1.059-1.645,0.436 c0-0.62,1.074-1.124,2.053-1.124C304.609,230.349,305.523,231.473,305.523,231.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.372,230.546c0.018,0.053-0.327,0.093-0.765,0.25c-0.438,0.16-0.727,0.467-0.748,0.414 c-0.019-0.054,0.241-0.445,0.679-0.604C302.977,230.448,303.352,230.493,303.372,230.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#683C11"
    },
    d: "M304.514,230.616c0,0,0.376,0.212,0.7,0.212c0.702,0,0.702-0.399,0.702-0.399 s-0.119,0.798-0.709,0.795c-0.197,0-0.462-0.163-0.462-0.163L304.514,230.616z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.983,229.17c0,0,0.6-1.044,3.333-1.187c1.014-0.053,2.096,0.963,2.061,0.605c-0.036-0.358-0.567-1.523-2.034-1.523 C289.822,227.065,288.983,229.17,288.983,229.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M292.442,233.907c0,0.173,0.229,0.314,0.513,0.314c0.285,0,0.516-0.142,0.516-0.314 c0-0.173-0.23-0.315-0.516-0.315C292.671,233.592,292.442,233.734,292.442,233.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M291.18,234.168c0,0.108,0.17,0.195,0.377,0.195c0.205,0,0.374-0.087,0.374-0.195 c0-0.108-0.169-0.194-0.374-0.194C291.35,233.974,291.18,234.059,291.18,234.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M289.756,233.974c0,0.106,0.166,0.194,0.375,0.194c0.207,0,0.376-0.088,0.376-0.194 c0-0.107-0.169-0.193-0.376-0.193C289.922,233.78,289.756,233.866,289.756,233.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M292.066,234.68c0,0.046,0.107,0.084,0.241,0.084c0.133,0,0.241-0.038,0.241-0.084 c0-0.048-0.108-0.086-0.241-0.086C292.174,234.594,292.066,234.632,292.066,234.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M289.311,233.592c0,0.047,0.079,0.085,0.174,0.085c0.098,0,0.175-0.038,0.175-0.085 c0-0.046-0.077-0.086-0.175-0.086C289.391,233.506,289.311,233.546,289.311,233.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M291.381,235.02c0,0.05,0.078,0.089,0.176,0.089c0.096,0,0.174-0.039,0.174-0.089 c0-0.045-0.078-0.082-0.174-0.082C291.459,234.938,291.381,234.975,291.381,235.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M290.66,234.446c0,0.049,0.109,0.087,0.241,0.087c0.134,0,0.243-0.038,0.243-0.087 c0-0.047-0.109-0.083-0.243-0.083C290.77,234.363,290.66,234.399,290.66,234.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M290.938,233.592c0,0.047,0.109,0.085,0.242,0.085c0.135,0,0.242-0.038,0.242-0.085 c0-0.046-0.107-0.086-0.242-0.086C291.047,233.506,290.938,233.546,290.938,233.592z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAD6D5"
    },
    d: "M290.074,231.701c0,0,0.516-0.343,2.176-0.17c0.972,0.101,1.694,0.763,1.757,0.278 c0.085-0.614-1.063-1.024-2.038-1.024C290.988,230.785,290.074,231.701,290.074,231.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#683C11"
    },
    d: "M290.074,231.701c0,0,0.642-0.61,2.301-0.438c0.973,0.1,1.642,1.059,1.642,0.438 c0-0.621-1.073-1.124-2.049-1.124C290.988,230.577,290.074,231.701,290.074,231.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M292.227,230.774c-0.021,0.051,0.326,0.094,0.764,0.25c0.439,0.158,0.727,0.465,0.747,0.413 c0.018-0.053-0.24-0.446-0.677-0.605C292.622,230.675,292.244,230.72,292.227,230.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#683C11"
    },
    d: "M291.084,230.843c0,0-0.375,0.212-0.701,0.212c-0.701,0-0.701-0.4-0.701-0.4 s0.119,0.799,0.71,0.795c0.196,0,0.46-0.163,0.46-0.163L291.084,230.843z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282727"
    },
    d: "M306.344,217.596c0,0,0.343,3.532,1.31,5.297c0.965,1.768,3.459,4.528,3.459,4.528 s0.624-5.773-0.626-7.538c-1.244-1.768-3.482-3.013-3.482-3.013L306.344,217.596z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8254"
    },
    points: "330.32,250.071 331.911,250.61 335.076,245.62 334.637,244.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8254"
    },
    points: "329.67,249.264 330.864,249.783 333.237,244.287 332.454,243.997  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BF8254"
    },
    points: "328.628,248.845 329.664,249.583 330.71,244.521 330.103,244.352  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF8254"
    },
    d: "M318.011,275.153c1.196-4.399,8.384-20.922,8.384-20.922l-0.615-3.829l0.816-3.041l0.891,0.167 l0.309,2.52l0.833-1.385l3.173,1.501l3.549-3.225l0.373,0.527l-3.467,4.79l-2.904,3.124c0,0-4.084,15.95-5.287,19.405 C322.864,278.239,316.383,281.133,318.011,275.153z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0E8E6"
    },
    d: "M324.594,269.858c0.529-3.397,0.313-7.627,2.425-10.518c0.548-0.742,1.176-1.391,1.833-2.01 c-1.131,4.36-3.844,14.746-4.787,17.455c-0.574,1.656-2.367,3.183-3.898,3.663C322.55,276.255,324.027,273.52,324.594,269.858z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.902,246.071c-0.461,0.76-2.258,1.625-4.383,0.335c-2.126-1.289-1.975-3.097-1.514-3.855 c0.459-0.76,0.958,0.158,3.086,1.445C290.217,245.286,291.363,245.313,290.902,246.071z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M290.453,248.388c-0.461,0.76-2.257,1.625-4.383,0.337c-2.127-1.291-1.976-3.098-1.515-3.857 c0.461-0.758,0.96,0.156,3.086,1.445C289.767,247.602,290.912,247.629,290.453,248.388z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.58,246.355c0.148,0.873-0.267,3.498-2.719,3.912c-2.45,0.412-3.899-1.851-4.046-2.727 c-0.147-0.875,0.829-0.508,3.279-0.919C289.547,246.207,290.433,245.477,290.58,246.355z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M290.694,250.96c-0.229,0.857-1.71,2.195-4.112,1.559c-2.402-0.639-2.767-2.415-2.539-3.273 c0.228-0.857,0.965-0.118,3.367,0.518C289.813,250.4,290.921,250.102,290.694,250.96z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290.24,248.973c0.389,0.798,0.549,3.398-1.688,4.485c-2.234,1.086-4.08-0.641-4.467-1.438 c-0.389-0.8,0.651-0.721,2.887-1.81C289.21,249.124,289.853,248.174,290.24,248.973z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M291.59,253.324c-0.006,0.889-1.104,2.554-3.59,2.537c-2.486-0.015-3.283-1.644-3.277-2.529 c0.004-0.89,0.902-0.36,3.389-0.343C290.598,253.002,291.594,252.438,291.59,253.324z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M290.652,251.515c0.578,0.674,0.834,2.653-1.059,4.267c-1.893,1.612-3.56,0.898-4.135,0.224 c-0.577-0.674,0.447-0.861,2.342-2.475C289.691,251.919,290.078,250.838,290.652,251.515z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M292.131,253.688c0.527,0.711,1.344,3.24-0.653,4.718c-2.001,1.478-4.315,0.114-4.842-0.6s0.51-0.827,2.509-2.306 C291.145,254.023,291.603,252.972,292.131,253.688z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M294.316,257.743c0.188,0.87-0.529,2.732-2.962,3.25c-2.431,0.52-3.56-0.9-3.745-1.768 c-0.186-0.867,0.807-0.544,3.238-1.064C293.277,257.642,294.133,256.875,294.316,257.743z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M293.014,256.177c0.709,0.535,2.027,2.782,0.525,4.763c-1.502,1.98-3.928,1.274-4.635,0.738 c-0.708-0.536,0.256-0.939,1.756-2.919C292.162,256.778,292.306,255.639,293.014,256.177z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M292.961,263.995c0.836-0.298,3.036-1.865,4.014,0.42c2.463,5.77-0.32,12.361-1.652,13.081 c1.119-4.779-2.287-7.05-1.495-10.114C292.995,265.037,292.123,264.292,292.961,263.995z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M295.559,262.628c0.834-0.297,4.954,0.667,5.928,2.953c2.464,5.769-2.236,9.827-3.566,10.547 c1.119-4.778-2.289-7.048-1.496-10.114C295.592,263.671,294.721,262.927,295.559,262.628z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M296.185,259.448c0.397,0.794,0.171,2.774-2.053,3.888c-2.225,1.111-3.673,0.018-4.068-0.776 c-0.398-0.794,0.643-0.728,2.867-1.84C295.154,259.608,295.789,258.654,296.185,259.448z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M294.531,258.255c0.819,0.342,1.944,1.99,0.986,4.285c-0.959,2.295-2.77,2.414-3.587,2.072 c-0.819-0.342,0.011-0.971,0.969-3.267C293.859,259.052,293.713,257.913,294.531,258.255z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D84B58"
    },
    d: "M294.405,264.323c1.042,1.443-1.196,4.841-1.566,5.109c-0.371,0.27-2.708-1.248-2.561-2.126 c-0.831,0.33-1.587-2.829-1.216-3.098C289.434,263.941,293.36,262.882,294.405,264.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD434D"
    },
    d: "M293.416,266.964c-0.801,0.752-2.184,0.796-2.774-0.267c-0.444-0.808-0.961-1.733-1.591-2.472 c-0.338,0.336,0.406,3.408,1.228,3.081c-0.147,0.878,2.189,2.395,2.561,2.126c0.346-0.249,2.298-3.198,1.735-4.773 C294.488,265.497,294.127,266.302,293.416,266.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D84B58"
    },
    d: "M295.303,263.674c1.043,1.443,4.971,0.384,5.341,0.116c0.371-0.268-0.335-2.963-1.218-3.098 c0.576-0.686-2.188-2.395-2.559-2.125C296.495,258.833,294.26,262.231,295.303,263.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD434D"
    },
    d: "M298.119,263.563c0.962-0.524,1.439-1.825,0.615-2.718c-0.627-0.676-1.344-1.457-1.848-2.285 c0.424-0.216,3.107,1.454,2.539,2.132c0.883,0.135,1.589,2.829,1.218,3.098c-0.345,0.25-3.759,1.181-5.077,0.151 C296.389,264.121,297.267,264.031,298.119,263.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D84B58"
    },
    d: "M296.017,263.147c0.561,0.773,1.015,1.401-0.259,2.322c-1.137,0.822-1.728,0.293-2.287-0.483 c-0.561-0.773-1.016-1.401,0.26-2.321C295.003,261.743,295.457,262.371,296.017,263.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD434D"
    },
    d: "M295.559,264.546c-1.137,0.823-1.727,0.293-2.287-0.483c-0.119-0.164-0.229-0.324-0.323-0.479 c-0.139,0.484,0.169,0.915,0.522,1.402c0.56,0.776,1.15,1.306,2.287,0.483c1.002-0.724,0.931-1.269,0.585-1.844 C296.26,263.907,296.029,264.207,295.559,264.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M295.316,262.716c0.221,0.307,0.113,0.762-0.242,1.02 c-0.353,0.254-0.82,0.215-1.04-0.092c-0.224-0.306-0.114-0.762,0.239-1.018C294.628,262.371,295.094,262.41,295.316,262.716z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlein);
export default __webpack_public_path__ + "static/media/settle in.f770eaac1f6df626f343a75e467a1fc2.svg";
export { ForwardRef as ReactComponent };